<template>
  <div v-if="loading || redirectToPayement" ref="refHeight" class="loading-container">
    <div class="d-flex justify-content-center mt-5">
      <div class="spinner-border" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">{{ activity?.catalogueTraduction?.globalChargement || $t('global.chargement') }}</span>
      </div>
    </div>
  </div>
  <div v-else-if="hasError" ref="refHeight" class="error-container">
    <div class="m-5 alert alert-danger" role="alert">
      <h4 class="alert-heading">{{ $activity?.catalogueTraduction?.errorTitre || t('error.titre') }}</h4>
      <p>{{ activity?.catalogueTraduction?.errorMessage || $t('error.message') }}</p>
    </div>
  </div>
  <template v-else>
    <div v-if="activity.couverture" ref="refHeightCover" class="card">
      <img :alt="activity.couverture.media.alt" :src="widgetURL + activity.couverture.media.url" class="card-img-top"
           style="max-height: 350px;"/>
      <div class="card-img-overlay">
        <h1 class="card-title text-center mt-lg-5">{{ activity.libelle }}</h1>
      </div>
    </div>
    <div v-if="!viewProcessInscriptionAlternatif" ref="refHeightProgress" class="etapes progress">
      <div :aria-valuemax="progress" :aria-valuenow="progress"
           :class="progress >= 100 || validated ? 'bg-success' : 'bg-warning'" :style="{width: progress+'%'}"
           aria-valuemin="0" class="progress-bar"
           role="progressbar"></div>
    </div>
    <div ref="top" class="formulaire m-5 row">
      <div class="col-lg-8">
        <h1 v-if="!activity.couverture" class="titre">{{ activity.libelle }}</h1>

        <div v-if="widgetForm.etapes?.length > 0 && !viewProcessInscriptionAlternatif" class="mb-5">
          <ul class="nav nav-fill">
            <li v-for="(formStep, index) in widgetForm.etapes" :key="formStep.etape.id" class="nav-item me-3">
              <span
                  :class="{
                    'bg-success text-white bi-check-lg' : validedStep >= (index + 1),
                    'bg-warning text-white' : step === (index + 1) && validedStep < (index + 1),
                    'bg-light text-black' : step < (index + 1) && validedStep < (index + 1)
                  }"
                  class="nav-link nav-pills fw-bolder" v-text="validedStep < (index + 1) ? (index + 1) : ''"></span>
              <p :class="{'fw-bolder' : step === (index + 1)}">{{ formStep.etape.libelle }}</p>
            </li>
          </ul>
        </div>

        <div v-if="submiting" class="d-flex justify-content-center m-5">
          <div class="spinner-border" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">{{ activity?.catalogueTraduction?.globalChargement || $t('global.chargement') }}</span>
          </div>
        </div>

        <div v-if="widgetForm.premierePage && !validated && step === startStep && !viewProcessInscriptionAlternatif" v-html="widgetForm.premierePage"></div>
        <div v-if="activity.avantageMc && activity.reductionMC && activity.reductionMC > 0 && !validated && step === startStep && !viewProcessInscriptionAlternatif" v-html="activity.avantageMc"></div>


        <div v-if="widgetForm.formWebModSimple === 'true' && step === startStep" >
          <div v-html="activity.introPayant" />
          <a class="link" v-if="!viewProcessInscriptionAlternatif" @click="changeInscriptionAlternatif">{{ activity?.catalogueTraduction?.formLienInscriptionAlternative || $t('form.lienInscriptionAlternative') }}</a>
        </div>

        <div v-if="viewProcessInscriptionAlternatif" >
          <a class="link" @click="changeInscriptionAlternatif">{{ activity?.catalogueTraduction?.formLienInscriptionForm || $t('form.lienInscriptionForm') }}</a>
          <div v-html="activity.processusInscriptionAlternatif" />
        </div>

        <form v-if="widgetForm.etapes?.length > 0 && !validated && !bookingError && !viewProcessInscriptionAlternatif" ref="form" :class="{'was-validated' : submited}"
              class="needs-validation"
              method="post"
              novalidate
              @submit.prevent>

          <template v-for="formStep in widgetForm.etapes" :key="formStep.etape.id">
            <div v-if="step === formStep.numero" :class="stepClasses(formStep)" class="etape">

              <h3 v-if="formStep.titre" class="etape-titre">{{ formStep.titre }}</h3>
              <p v-if="formStep.introduction" class="etape-intro">{{ formStep.introduction }}</p>
              <template v-for="champ in formStep.champs" :key="champ.id">
                <div v-if="(champ.key !== constants.champs.INDIVIDU_TEL || (champ.key === constants.champs.INDIVIDU_TEL && !principalAdr))
                  && (champ.key !== constants.champs.INDIVIDU_EMAIL || (champ.key === constants.champs.INDIVIDU_EMAIL && !principalAdr))
                  && (champ.key !== constants.champs.INDIVIDU_MOBILE || (champ.key === constants.champs.INDIVIDU_MOBILE && !principalAdr))"
                     :class="step === startStep ?
                  (champ.key !== constants.champs.INDIVIDU_NRN
                  && champ.key !== constants.champs.INDIVIDU_ADR_PRINCIPALE
                  && champ.key !== constants.champs.INDIVIDU_ADR_FACTURATION
                  && champ.key !== constants.champs.INDIVIDU_ADR_URGENCE
                  && champ.key !== constants.champs.INDIVIDU_ADR_CONTACT_NOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_CONTACT_PRENOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_FACTURATION_NOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_FACTURATION_PRENOM
                  && champ.key !== constants.champs.PERIODES_PLAINE
                  && champ.key !== constants.champs.PERIODES_FORMATION
                  && champ.key !== constants.champs.CONTINGENTS
                  && champ.key !== constants.champs.QUESTIONS
                  && champ.key !== constants.champs.EMBARQUEMENTS
                  && champ.key !== constants.champs.DEBARQUEMENTS
                  && champ.key !== constants.champs.INSCRIPTION_MC
                  && champ.key !== constants.champs.INSCRIPTION_URGENCE_TELEPHONE ? 'champ col-md-6' : 'champ col-md-12') : 'champ'">

                  <label v-if="champ.key !== constants.champs.PERIODES_PLAINE
                  && champ.key !== constants.champs.PERIODES_FORMATION
                  && champ.key !== constants.champs.INDIVIDU_NRN
                  && champ.key !== constants.champs.INDIVIDU_ADR_CONTACT_NOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_CONTACT_PRENOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_FACTURATION_NOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_FACTURATION_PRENOM
                  && champ.key !== constants.champs.INDIVIDU_ADR_PRINCIPALE
                  && champ.key !== constants.champs.INDIVIDU_ADR_FACTURATION
                  && champ.key !== constants.champs.INDIVIDU_ADR_URGENCE
                  && champ.key !== constants.champs.CONTINGENTS
                  && champ.key !== constants.champs.QUESTIONS
                  && champ.key !== constants.champs.EMBARQUEMENTS
                  && champ.key !== constants.champs.DEBARQUEMENTS
                  && champ.key !== constants.champs.RESUME
                  && champ.key !== constants.champs.INSCRIPTION_MC
                  && champ.key !== constants.champs.RESUME
                  && champ.key !== constants.champs.PLACES
                  && champ.key !== constants.champs.INSCRIPTION_URGENCE_TELEPHONE
                  && champ.key !== constants.champs.INDIVIDU_MOBILE
                  && champ.key !== constants.champs.INDIVIDU_TEL"
                         :for="champ.key" class="form-label">{{ champ.libelle }}<span
                      v-if="champ.obligatoire">&nbsp;</span><i
                      v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i></label>

                  <div v-if="champ.key === constants.champs.INDIVIDU_PRENOM" class="input-group mb-3 has-validation">
                    <input :id="champ.key" v-model="booking.prenom" :name="champ.key" :required="champ.obligatoire"
                           class="form-control" type="text"
                           @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                  <div v-else-if="champ.key === constants.champs.INDIVIDU_NOM"
                       class="input-group mb-3 has-validation">
                    <input :id="champ.key" v-model="booking.nom" :name="champ.key" :required="champ.obligatoire"
                           class="form-control" type="text"
                           @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_NAISSANCE"
                      class="input-group mb-3 has-validation">
                    <input :id="champ.key" v-model="booking.naissance" :name="champ.key" :required="champ.obligatoire"
                           :class="['form-control', { 'is-invalid': birthdateValidationError }]" type="date" @blur="onFormInputBlur(champ.obligatoire, $event); validateBirthDate()"/>
                    <div class="invalid-feedback" v-if="birthdateValidationError || contingentsGroupesValidationError">
                      {{ activity?.catalogueTraduction?.formAgeConstraintValidationerror || $t('form.ageConstraintValidationError') }}
                    </div>
                    <div class="invalid-feedback" v-else-if="noContingentGroupeSelectedError">
                      {{ activity?.catalogueTraduction?.formNoContingentSelectedError || $t('form.noContingentSelectedError') }}
                    </div>
                    <div class="invalid-feedback" v-else-if="!booking.naissance">
                      {{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}
                    </div>
                  </div>
                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_EMAIL && !principalAdr"
                      class="input-group mb-3 has-validation">
                    <span class="input-group-text">@</span>
                    <input :id="champ.key" v-model="booking.email" :name="champ.key" :required="champ.obligatoire"
                           class="form-control" type="email" @blur="onFormInputBlur(true, $event)"/>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }} et doit être un format d'email valide
                    </div>
                  </div>
                  <template v-else-if="champ.key === constants.champs.INDIVIDU_NRN && !activity.validationAutomatique">
                    <div class="input-group mb-3 has-validation">
                      <input :id="champ.key" v-model="booking.nrn" v-maska="['## ## ## ###-##', '## ## ## ###-##']"
                             :aria-describedby="champ.key + 'Help'"
                             :name="champ.key"
                             :placeholder="activity?.catalogueTraduction?.formFormatNrn || $t('form.formatNrn')" class="form-control mw-300"
                             pattern="^([0-9]{2} ){3}([0-9]{3}-){1}[0-9]{2}$"
                             type="text"
                             @blur="onNrnInputBlur(true, $event)"/>
                      <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formTrouverNrn || $t('form.trouverNrn') }}</div>
                      <div class="invalid-feedback">{{
                          champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') + ', ' + activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                        }}
                      </div>
                    </div>
                  </template>
                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_LANGUE"
                      class="input-group mb-3 has-validation">
                    <select :id="champ.key" v-model="booking.langue" :name="champ.key" :required="champ.obligatoire"
                            class="form-select" @blur="onFormInputBlur(true, $event)">
                      <option selected value="fr">{{ activity?.catalogueTraduction?.formLanguesFr || $t('form.langues.fr') }}</option>
                      <option value="nl">{{ activity?.catalogueTraduction?.formLanguesNl || $t('form.langues.nl') }}</option>
                      <option value="lu">{{ activity?.catalogueTraduction?.formLanguesLu || $t('form.langues.lu') }}</option>
                      <option value="de">{{ activity?.catalogueTraduction?.formLanguesDe || $t('form.langues.de') }}</option>
                      <option value="autre">{{ activity?.catalogueTraduction?.formAutre || $t('form.autre') }}</option>
                    </select>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_NATIONALITE"
                      class="input-group mb-3 has-validation">
                    <select :id="champ.key" v-model="booking.nationalite" :name="champ.key"
                            :required="champ.obligatoire"
                            class="form-select" @blur="onFormInputBlur(champ.obligatoire, $event)">
                      <option selected value="BE">{{ activity?.catalogueTraduction?.formNationalitesBe || $t('form.nationalites.be') }}</option>
                      <option value="LU">{{ activity?.catalogueTraduction?.formNationalitesLu || $t('form.nationalites.lu') }}</option>
                      <option value="DE">{{ activity?.catalogueTraduction?.formNationalitesDe || $t('form.nationalites.de') }}</option>
                      <option value="FR">{{ activity?.catalogueTraduction?.formNationalitesFr || $t('form.nationalites.fr') }}</option>
                      <option value="autre">{{ activity?.catalogueTraduction?.formAutre || $t('form.autre') }}</option>
                    </select>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                  <!--
                  <div v-else-if="champ.key === constants.champs.INDIVIDU_TEL && !principalAdr"
                       class="input-group mb-3 has-validation">
                    <span class="input-group-text">&#9742;</span>
                    <input :id="champ.key" v-model="booking.telephone" :name="champ.key" :required="champ.obligatoire"
                           class="form-control"
                           pattern="(^0032(?:\s\d{1}\s\d{2}\s\d{2}\s\d{2}|\s\d{2}\s\d{2}\s\d{2}\s\d{2})?$)"
                           type="tel" @blur="onFormInputBlur(true, $event)"/>
                    <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formFormatTel || $t('form.formatTel') }}</div>
                    <div class="invalid-feedback">
                      <template v-if="champ.obligatoire">{{activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')}}.</template>
                      {{activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')}}
                    </div>
                  </div>
                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_MOBILE && !principalAdr"
                      class="input-group mb-3 has-validation">
                    <span class="input-group-text">&#9742;</span>
                    <input :id="champ.key" v-model="booking.mobile" :name="champ.key" :required="champ.obligatoire"
                           class="form-control"
                           pattern="(^0032(?:\s\d{3}\s\d{2}\s\d{2}\s\d{2})?$)"
                           type="tel" @blur="onFormInputBlur(true, $event)"/>
                    <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formFormatMobile || $t('form.formatMobile') }}</div>
                    <div class="invalid-feedback">
                      <template v-if="champ.obligatoire">{{activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')}}.</template>
                      {{activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')}}
                    </div>
                  </div>
                  -->
                  <div v-else-if="champ.key === constants.champs.INDIVIDU_SEXE"
                       class="input-group mb-3 has-validation">
                    <div class="form-check form-check-inline">
                      <input id="inlineRadioH" v-model="booking.sexe" :name="champ.key" :required="champ.obligatoire"
                             class="form-check-input" type="radio" value="M">
                      <label class="form-check-label" for="inlineRadioH">{{ activity?.catalogueTraduction?.formSexesHomme || $t('form.sexes.homme') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input id="inlineRadioF" v-model="booking.sexe" :name="champ.key" :required="champ.obligatoire"
                             class="form-check-input" type="radio" value="F">
                      <label class="form-check-label" for="inlineRadioF">{{ activity?.catalogueTraduction?.formSexesFemme || $t('form.sexes.femme') }}</label>
                    </div>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                  <template v-else-if="champ.key === constants.champs.PLACES && activity.inscriptionsMultiples">
                    <label
                        :for="champ.key" class="form-label">{{ champ.libelle }}<span
                        v-if="champ.obligatoire">&nbsp;</span><i
                        v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i></label>
                    <div class="input-group mb-3 has-validation">
                      <input :id="champ.key" v-model="booking.places" :max="activity.inscriptionPlacesMax"
                             :name="champ.key"
                             :required="champ.obligatoire" class="form-control" min="1" type="number"
                             @input="handleChangePlaces($event)"
                             @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                      <div class="invalid-feedback">
                        {{ activity?.catalogueTraduction?.formErreurMaxPlaces || $t('form.erreurMaxPlaces', {nb_places: activity.inscriptionPlacesMax}) }}
                      </div>
                    </div>
                    <div v-if="activity.validationAutomatique && activity.reductionMC" v-html="activity.inscriptionMultiple" />
                  </template>
                  <div
                      v-else-if="champ.key === constants.champs.REMARQUES_ADMIN"
                      class="input-group mb-3 has-validation">
                    <textarea :id="champ.key" v-model="booking.remarquesAdmin" :name="champ.key"
                              :required="champ.obligatoire" class="form-control"
                              rows="4" @blur="onFormInputBlur(champ.obligatoire, $event)"></textarea>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                  <div
                      v-else-if="champ.key === constants.champs.REMARQUES_PEDA"
                      class="input-group mb-3 has-validation">
                    <textarea :id="champ.key" v-model="booking.remarquesPeda" :name="champ.key"
                              :required="champ.obligatoire" class="form-control"
                              rows="4" @blur="onFormInputBlur(champ.obligatoire, $event)"></textarea>
                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_ADR_PRINCIPALE"
                      class="card mb-3">
                    <div class="card-header">{{ champ.libelle }}</div>
                    <div class="card-body row g-3">

                      <div v-if="principalAdrPrenom" class="col-md-6">
                        <label :for="champ.key + '_prenom'" class="form-label">{{ principalAdrPrenom.libelle }}
                          <span v-if="principalAdrPrenom.obligatoire">&nbsp;</span>
                          <i v-if="principalAdrPrenom.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <input :id="champ.key + '_prenom'" v-model="booking.adresse.prenom"
                               :name="champ.key + '_prenom'" class="form-control"
                               type="text" :required="principalAdrPrenom.obligatoire"
                               @blur="onFormInputBlur(principalAdrPrenom.obligatoire, $event)"/>
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div v-if="principalAdrNom" class="col-md-6">
                        <label :for="champ.key + '_nom'" class="form-label">{{ principalAdrNom.libelle }}
                          <span v-if="principalAdrNom.obligatoire">&nbsp;</span>
                          <i v-if="principalAdrNom.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <input :id="champ.key + '_nom'" v-model="booking.adresse.nom" :name="champ.key + '_nom'"
                               class="form-control"
                               type="text" :required="principalAdrNom.obligatoire"
                               @blur="onFormInputBlur(principalAdrNom.obligatoire, $event)"/>
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div v-if="principalMail" class="col-md-12">
                        <label :for="champ.key + '_email'" class="form-label">{{ principalMail.libelle }}
                          <span v-if="principalMail.obligatoire">&nbsp;</span>
                          <i v-if="principalMail.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text">@</span>
                          <input :id="champ.key + '_email'" v-model="booking.adresse.email" :name="champ.key + '_email'"
                                 class="form-control" :required="principalMail.obligatoire"
                                 type="email" @blur="onFormInputBlur(principalMail.obligatoire, $event)"/>
                          <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }} et doit être un format d'email
                            valide
                          </div>
                        </div>
                      </div>


                      <div v-if="principalTelephone" class="col-4 col-md-3">
                        <label :for="champ.key + '_prefix'" class="form-label">
                          {{ activity?.catalogueTraduction?.formTelephonePrefix || $t('form.formTelephonePrefix') }}
                        </label>
                        <select :id="champ.key" v-model="booking.adresse.telPrefix" :name="champ.key + '_prefix'"
                                :required="champ.obligatoire"
                                class="form-select" @blur="onFormInputBlur(true, $event)">
                          <option selected value="0032">+32</option>
                          <option value="0033">+33</option>
                          <option value="0031">+31</option>
                          <option value="0049">+49</option>
                          <option value="00352">+352</option>
                        </select>
                      </div>
                      <div v-if="principalTelephone" class="col-8 col-md-9">
                        <label :for="champ.key + '_mobile'" class="form-label">{{principalTelephone.libelle}}
                          <span v-if="principalTelephone.obligatoire">&nbsp;</span>
                          <i v-if="principalTelephone.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <div class="input-group mb-3 has-validation">
                          <input :id="champ.key + '_tel'" v-model="booking.adresse.tel"
                                 :name="champ.key + '_tel'"
                                 :required="principalTelephone.obligatoire"
                                 class="form-control"
                                 :pattern="getPhonePattern(booking.adresse.telPrefix, 'tel')"
                                 v-maska="getPhoneMaska(booking.adresse.telPrefix, 'tel')"
                                 type="tel" @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                          <div :id="champ.key + 'Help'" class="form-text">
                            <template v-if="booking.adresse.telPrefix === '0032'">
                              {{ activity.catalogueTraduction.formFormatTelephoneBe }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '0033'">
                              {{ activity?.catalogueTraduction?.formFormatTelephoneFr }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '0031'">
                              {{ activity?.catalogueTraduction?.formFormatTelephoneNl }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '0049'">
                              {{ activity?.catalogueTraduction?.formFormatTelephoneDe }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '00352'">
                              {{ activity?.catalogueTraduction?.formFormatTelephoneLu }}
                            </template>
                          </div>
                          <div class="invalid-feedback">
                            {{
                              principalTelephone.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                            }}
                            <br v-if="principalTelephone.obligatoire" />
                            <template v-if="booking.adresse.telPrefix === '0032'">
                              {{ activity?.catalogueTraduction?.formErreurFormatTelephoneBe }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '0033'">
                              {{ activity?.catalogueTraduction?.formErreurFormatTelephoneFr }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '0031'">
                              {{ activity?.catalogueTraduction?.formErreurFormatTelephoneNl }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '0049'">
                              {{ activity?.catalogueTraduction?.formErreurFormatTelephoneDe }}
                            </template>
                            <template v-if="booking.adresse.telPrefix === '00352'">
                              {{ activity?.catalogueTraduction?.formErreurFormatTelephoneLu }}
                            </template>
                          </div>
                        </div>
                      </div>
                      <!--
                      <div v-if="principalTelephone" class="col-md-12">
                        <label :for="champ.key + '_tel'" class="form-label">{{ principalTelephone.libelle }}
                          <span v-if="principalTelephone.obligatoire">&nbsp;</span>
                          <i v-if="principalTelephone.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text">&#9742;</span>
                          <input :id="champ.key + '_tel'" v-model="booking.adresse.tel" :name="champ.key + '_tel'"
                                 :required="principalTelephone.obligatoire" class="form-control"
                                 pattern="(^0032(?:\s\d{1}\s\d{2}\s\d{2}\s\d{2}|\s\d{2}\s\d{2}\s\d{2}\s\d{2})?$)"
                                 type="tel" @blur="onFormInputPhoneBlur($event)"/>
                          <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formFormatTel || $t('form.formatTel') }}</div>
                          <div class="invalid-feedback">
                              <template v-if="principalTelephone.obligatoire">{{activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')}}.</template>
                              {{activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')}}
                          </div>
                        </div>
                      </div>
                      -->

                      <div v-if="principalGSM" class="col-4 col-md-3">
                        <label :for="champ.key + '_prefix'" class="form-label">
                          {{ activity?.catalogueTraduction?.formTelephonePrefix || $t('form.formTelephonePrefix') }}
                        </label>
                        <select :id="champ.key" v-model="booking.adresse.mobilePrefix" :name="champ.key + '_prefix'"
                                :required="champ.obligatoire"
                                class="form-select" @blur="onFormInputBlur(true, $event)">
                          <option selected value="0032">+32</option>
                          <option value="0033">+33</option>
                          <option value="0031">+31</option>
                          <option value="0049">+49</option>
                          <option value="00352">+352</option>
                        </select>
                      </div>
                      <div v-if="principalGSM" class="col-8 col-md-9">
                        <label :for="champ.key + '_mobile'" class="form-label">{{principalGSM.libelle}}
                          <span v-if="principalGSM.obligatoire">&nbsp;</span>
                          <i v-if="principalGSM.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <div class="input-group mb-3 has-validation">
                          <input :id="champ.key + '_mobile'" v-model="booking.adresse.mobile"
                                 :name="champ.key + '_mobile'"
                                 :required="principalGSM.obligatoire"
                                 class="form-control"
                                 :pattern="getPhonePattern(booking.adresse.mobilePrefix, 'mobi')"
                                 v-maska="getPhoneMaska(booking.adresse.mobilePrefix, 'mobi')"
                                 type="tel" @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                          <div :id="champ.key + 'Help'" class="form-text">
                            <template v-if="booking.adresse.mobilePrefix === '0032'">
                              {{ activity?.catalogueTraduction?.formFormatMobileBe || $t('form.formatMobileBe') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '0033'">
                              {{ activity?.catalogueTraduction?.formFormatMobileFr || $t('form.formatMobileFr') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '0031'">
                              {{ activity?.catalogueTraduction?.formFormatMobileNl || $t('form.formatMobileNl') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '0049'">
                              {{ activity?.catalogueTraduction?.formFormatMobileDe || $t('form.formatMobileDe') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '00352'">
                              {{ activity?.catalogueTraduction?.formFormatMobileLu || $t('form.formatMobileLu') }}
                            </template>
                          </div>
                          <div class="invalid-feedback">
                            {{
                              principalGSM.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                            }}
                            <br v-if="principalGSM.obligatoire" />
                            <template v-if="booking.adresse.mobilePrefix === '0032'">
                              {{ activity?.catalogueTraduction?.formErreurFormatMobile || $t('form.formErreurFormatMobile') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '0033'">
                              {{ activity?.catalogueTraduction?.formErreurFormatMobileFr || $t('form.formErreurFormatMobileFr') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '0031'">
                              {{ activity?.catalogueTraduction?.formErreurFormatMobileNl || $t('form.formErreurFormatMobileNl') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '0049'">
                              {{ activity?.catalogueTraduction?.formErreurFormatMobileDe || $t('form.formErreurFormatMobileDe') }}
                            </template>
                            <template v-if="booking.adresse.mobilePrefix === '00352'">
                              {{ activity?.catalogueTraduction?.formErreurFormatMobileLu || $t('form.formErreurFormatMobileLu') }}
                            </template>
                          </div>
                        </div>
                      </div>
                      <!--
                      <div v-if="principalGSM" class="col-md-12">
                        <label :for="champ.key + '_mobile'" class="form-label">{{ principalGSM.libelle }}
                          <span v-if="principalGSM.obligatoire">&nbsp;</span>
                          <i v-if="principalGSM.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text">&#9742;</span>
                          <input :id="champ.key + '_mobile'" v-model="booking.adresse.mobile"
                                 :name="champ.key + '_mobile'" :required="principalGSM.obligatoire" class="form-control"
                                 pattern="(^0032(?:\s\d{3}\s\d{2}\s\d{2}\s\d{2})?$)"
                                 type="tel" @blur="onFormInputPhoneBlur($event)"/>
                          <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formFormatMobile || $t('form.formatMobile') }}</div>
                          <div class="invalid-feedback">
                            <template v-if="principalGSM.obligatoire">{{activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')}}.</template>
                            {{activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')}}
                          </div>
                        </div>
                      </div>
                      -->
                      <div class="col-md-12">
                        <label :for="champ.key + '_pays'" class="form-label">{{ activity?.catalogueTraduction?.formAdressePays || $t('form.adresse.pays') }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <select :id="champ.key + '_pays'" v-model="booking.adresse.pays" :name="champ.key + '_pays'"
                                :required="champ.obligatoire" class="form-select"
                                @blur="onFormInputBlur(champ.obligatoire, $event)">
                          <option selected value="BE">{{ activity?.catalogueTraduction?.formPaysBelgique || $t('form.pays.belgique') }}</option>
                          <option value="FR">{{ activity?.catalogueTraduction?.formPaysFrance || $t('form.pays.france') }}</option>
                          <option value="LU">{{ activity?.catalogueTraduction?.formPaysLuxembourg || $t('form.pays.luxembourg') }}</option>
                          <option value="DE">{{ activity?.catalogueTraduction?.formPaysAllemagne || $t('form.pays.allemagne') }}</option>
                          <option value="NL">{{ activity?.catalogueTraduction?.formPaysPaysBas || $t('form.pays.paysbas') }}</option>
                        </select>
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div class="col-md-12" v-if="booking.adresse.pays !== 'BE'">
                        <label :for="champ.key + '_rue'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseAdresse || $t('form.adresse.adresse') }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <input :id="champ.key + '_rue'" v-model="booking.adresse.rue"
                               :name="champ.key + '_rue'"
                               :required="champ.obligatoire" class="form-control" maxlength="250" type="text"
                               @blur="onFormInputBlur(champ.obligatoire, $event)">
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div class="col-md-12" ref="containerCp" v-if="booking.adresse.pays === 'BE'">
                        <label :for="champ.key + '_cp'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseCp || $t('form.adresse.cp') }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>

                        <Select2 class="form-control" v-model="selectedLocality" :options="getAllLocalities()" :settings="{ tags: false, allowClear : true }"
                                 @select="cpSelectEvent($event)" :required="champ.obligatoire" />

                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div class="col-md-8" v-if="booking.adresse.cp && booking.adresse.pays === 'BE'" ref="containerStreet">
                        <label :for="champ.key + '_adresse'" class="form-label">{{
                            activity?.catalogueTraduction?.formAdresseAdresse || $t('form.adresse.adresse')
                          }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <Select2 v-model="booking.adresse.bosa" :options="getAllStreets()" :settings="{ tags: true, allowClear : true }"
                                 class="form-control" @select="streetSelectEvent($event)" :required="champ.obligatoire" :disabled="loadingStreets"/>

                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div class="col-md-2" v-if="(booking.adresse.cp && booking.adresse.pays === 'BE') || booking.adresse.pays !== 'BE'">
                        <label :for="champ.key + '_numero'" class="form-label">
                          {{ activity?.catalogueTraduction?.formAdresseNumero || $t('form.adresse.numero') }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <input :id="champ.key + '_numero'" v-model="booking.adresse.numero"
                               :name="champ.key + '_numero'"
                               :required="champ.obligatoire" class="form-control" maxlength="5" type="text"
                               @blur="onFormInputBlur(champ.obligatoire, $event)">
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div class="col-md-2" v-if="(booking.adresse.cp && booking.adresse.pays === 'BE') || booking.adresse.pays !== 'BE'">
                        <label :for="champ.key + '_boite'" class="form-label">
                          {{ activity?.catalogueTraduction?.formAdresseBoite || $t('form.adresse.boite') }}
                        </label>
                        <input :id="champ.key + '_boite'" v-model="booking.adresse.boite" :name="champ.key + '_boite'"
                               class="form-control"
                               maxlength="5"
                               type="text">
                      </div>
                      <div class="col-md-8" v-if="booking.adresse.pays !== 'BE'">
                      </div>
                      <div class="col-md-4" v-if="booking.adresse.pays !== 'BE'">
                        <label :for="champ.key + '_cp'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseCpEtranger || $t('form.adresse.cpEtranger') }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <input :id="champ.key + '_cp'" v-model="booking.adresse.cp"
                               :name="champ.key + '_cp'"
                               :required="champ.obligatoire" class="form-control" maxlength="10" type="text"
                               @blur="onFormInputBlur(champ.obligatoire, $event)">
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                      <div class="col-md-8" v-if="booking.adresse.pays !== 'BE'">
                        <label :for="champ.key + '_ville'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseVille || $t('form.adresse.ville') }}
                          <span v-if="champ.obligatoire">&nbsp;</span>
                          <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <input :id="champ.key + '_ville'" v-model="booking.adresse.ville"
                               :name="champ.key + '_ville'"
                               :required="champ.obligatoire" class="form-control" maxlength="100" type="text"
                               @blur="onFormInputBlur(champ.obligatoire, $event)">
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INSCRIPTION_MC && (!activity.validationAutomatique || !activity.reductionMC || booking.places > 1)"
                      class="form-check mb-3" style="padding-left:0;">

                    <label :for="champ.key" class="form-check-label" style="font-weight: bold;">{{ champ.libelle }}</label>
                    <div class="d-flex align-items-center flex-row">
                      <div class="p-2">
                        <label>
                          <input
                              class="radio"
                              type="radio"
                              :name="champ.key"
                              :value="true"
                              :required="true"
                              v-model="booking.mc"
                              aria-controls="collapseFacturation"
                              aria-expanded="booking.mc"
                              data-bs-toggle="collapse"
                              @change="handleHeight"
                              @blur="onFormInputBlur(true, $event)"
                          >
                          <span class="radio-custom"></span>
                          <span class="radio-custom-label">Oui</span>
                        </label>
                        <label>
                          <input
                              class="radio"
                              type="radio"
                              :name="champ.key"
                              :value="false"
                              :required="true"
                              v-model="booking.mc"
                              @change="handleHeight"
                              @blur="onFormInputBlur(true, $event)"
                          >
                          <span class="radio-custom"></span>
                          <span class="radio-custom-label">Non</span>
                        </label>
                        <div class="invalid-feedback d-block" v-if="submited && (booking.mc === null || booking.mc === undefined)">
                          {{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_ADR_FACTURATION"
                      class="form-check form-switch mb-3">
                    <input :id="champ.key" v-model="booking.facturationIdentique" :name="champ.key"
                           aria-controls="collapseFacturation" aria-expanded="false" checked
                           class="form-check-input" data-bs-target="#collapseFacturation" data-bs-toggle="collapse"
                           role="switch"
                           type="checkbox"
                           @change="handleHeight">
                    <label :for="champ.key" class="form-check-label">{{
                        activity?.catalogueTraduction?.formAdresseFacturationIdentique || $t('form.adresse.facturationIdentique')
                      }}</label>

                    <div id="collapseFacturation" :class="{'show' : !booking.facturationIdentique}"
                         class="collapse mt-3">
                      <div class="card mb-3">
                        <div class="card-header">{{ champ.libelle }}</div>
                        <div class="card-body row g-3">

                          <div v-if="facturationAdrPrenom" class="col-md-6">
                            <label :for="champ.key + '_prenom'" class="form-label">{{
                                facturationAdrPrenom.libelle
                              }}</label>
                            <input :id="champ.key + '_prenom'" v-model="booking.facturation.prenom"
                                   :name="champ.key + '_prenom'" class="form-control"
                                   type="text"
                                   @blur="onFormInputBlur(facturationAdrPrenom.obligatoire, $event)"/>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div v-if="facturationAdrNom" class="col-md-6">
                            <label :for="champ.key + '_nom'" class="form-label">{{ facturationAdrNom.libelle }}</label>
                            <input :id="champ.key + '_nom'" v-model="booking.facturation.nom" :name="champ.key + '_nom'"
                                   class="form-control"
                                   type="text"
                                   @blur="onFormInputBlur(facturationAdrNom.obligatoire, $event)"/>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>

                          <div class="col-md-12">
                            <label :for="champ.key + '_pays'" class="form-label">{{ activity?.catalogueTraduction?.formAdressePays || $t('form.adresse.pays') }}
                              <span v-if="!booking.facturationIdentique">&nbsp;</span>
                              <i v-if="!booking.facturationIdentique" class="bi bi-asterisk text-danger"></i>
                            </label>
                            <select :id="champ.key + '_pays'" v-model="booking.facturation.pays"
                                    :name="champ.key + '_pays'"
                                    :required="!booking.facturationIdentique"
                                    class="form-select"
                                    @blur="onFormInputBlur(champ.obligatoire && !booking.facturationIdentique, $event)">
                              <option selected value="BE">{{ activity?.catalogueTraduction?.formPaysBelgique || $t('form.pays.belgique') }}</option>
                              <option value="FR">{{ activity?.catalogueTraduction?.formPaysFrance || $t('form.pays.france') }}</option>
                              <option value="LU">{{ activity?.catalogueTraduction?.formPaysLuxembourg || $t('form.pays.luxembourg') }}</option>
                              <option value="DE">{{ activity?.catalogueTraduction?.formPaysAllemagne || $t('form.pays.allemagne') }}</option>
                              <option value="NL">{{ activity?.catalogueTraduction?.formPaysPaysBas || $t('form.pays.paysbas') }}</option>
                            </select>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-12" v-if="booking.facturation.pays !== 'BE'">
                            <label :for="champ.key + '_rue'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseAdresse || $t('form.adresse.adresse') }}
                              <span v-if="champ.obligatoire">&nbsp;</span>
                              <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                            </label>
                            <input :id="champ.key + '_rue'" v-model="booking.facturation.rue"
                                  :name="champ.key + '_rue'"
                                  :required="champ.obligatoire" class="form-control" maxlength="250" type="text"
                                  @blur="onFormInputBlur(champ.obligatoire, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-12" ref="containerCpFact" v-if="booking.facturation.pays === 'BE'" id="cpFacturation">
                            <label :for="champ.key + '_cp'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseCp || $t('form.adresse.cp') }}</label>
                            <Select2 class="form-control" v-model="selectedFactLocality" :options="getAllLocalities()" :settings="{ tags: false, allowClear : true }"
                                     @select="cpFactSelectEvent($event)" :required="!booking.facturationIdentique"/>

                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-8" v-if="booking.facturation.cp && booking.facturation.pays === 'BE'" ref="containerStreetFact">
                            <label :for="champ.key + '_adresse'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseAdresse || $t('form.adresse.adresse')
                              }}</label>
                            <Select2 v-model="booking.facturation.bosa" :options="getAllFactStreets()" :settings="{ tags: true, allowClear : true }"
                                     class="form-control" @select="streetFactSelectEvent($event)" :required="!booking.facturationIdentique" :disabled="loadingFactStreets"/>

                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-2" v-if="(booking.facturation.cp && booking.facturation.pays === 'BE') || booking.facturation.pays !== 'BE'">
                            <label :for="champ.key + '_numero'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseNumero || $t('form.adresse.numero')
                              }}
                              <span v-if="!booking.facturationIdentique">&nbsp;</span>
                              <i v-if="!booking.facturationIdentique" class="bi bi-asterisk text-danger"></i>
                            </label>
                            <input :id="champ.key + '_numero'" v-model="booking.facturation.numero"
                                   :name="champ.key + '_numero'"
                                   :required="!booking.facturationIdentique"
                                   class="form-control" maxlength="5" type="text"
                                   @blur="onFormInputBlur(!booking.facturationIdentique, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-2" v-if="(booking.facturation.cp && booking.facturation.pays === 'BE') || booking.facturation.pays !== 'BE'">
                            <label :for="champ.key + '_boite'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseBoite || $t('form.adresse.boite')
                              }}</label>
                            <input :id="champ.key + '_boite'" v-model="booking.facturation.boite"
                                   :name="champ.key + '_boite'" class="form-control"
                                   maxlength="5" type="text">
                          </div>
                          <div class="col-md-8">
                          </div>
                          <div class="col-md-4" v-if="booking.facturation.pays !== 'BE'">
                            <label :for="champ.key + '_cp'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseCpEtranger || $t('form.adresse.cpEtranger') }}
                              <span v-if="champ.obligatoire">&nbsp;</span>
                              <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                            </label>
                            <input :id="champ.key + '_cp'" v-model="booking.facturation.cp"
                                  :name="champ.key + '_cp'"
                                  :required="champ.obligatoire" class="form-control" maxlength="10" type="text"
                                  @blur="onFormInputBlur(champ.obligatoire, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-8" v-if="booking.facturation.pays !== 'BE'">
                            <label :for="champ.key + '_ville'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseVille || $t('form.adresse.ville') }}
                              <span v-if="champ.obligatoire">&nbsp;</span>
                              <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                            </label>
                            <input :id="champ.key + '_ville'" v-model="booking.facturation.ville"
                                  :name="champ.key + '_ville'"
                                  :required="champ.obligatoire" class="form-control" maxlength="100" type="text"
                                  @blur="onFormInputBlur(champ.obligatoire, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INSCRIPTION_URGENCE_NOM"
                      class="input-group mb-3 has-validation">
                    <input :id="champ.key" v-model="booking.urgenceNom" :name="champ.key" :required="champ.obligatoire"
                           class="form-control"
                           @blur="onFormInputBlur(true, $event)"/>
                    <div class="invalid-feedback">{{
                        champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                      }}
                    </div>
                  </div>
                  <div
                      v-else-if="champ.key === constants.champs.INSCRIPTION_URGENCE_PRENOM"
                      class="input-group mb-3 has-validation">
                    <input :id="champ.key" v-model="booking.urgencePrenom" :name="champ.key"
                            :required="champ.obligatoire"
                            class="form-control"
                            @blur="onFormInputBlur(true, $event)"/>
                    <div class="invalid-feedback">{{
                          champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                        }}
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INSCRIPTION_URGENCE_TELEPHONE"
                      class="row">
                        <div class="col-4 col-md-3">
                          <label :for="champ.key + '_prefix'" class="form-label">
                            {{ activity?.catalogueTraduction?.formTelephonePrefix || $t('form.formTelephonePrefix') }}
                          </label>
                          <select :id="champ.key" v-model="booking.urgenceTelephonePrefix" :name="champ.key + '_prefix'"
                                  :required="champ.obligatoire"
                                  class="form-select" @blur="onFormInputBlur(true, $event)">
                            <option selected value="0032">+32</option>
                            <option value="0033">+33</option>
                            <option value="0031">+31</option>
                            <option value="0049">+49</option>
                            <option value="00352">+352</option>
                          </select>
                        </div>
                        <div class="col-8 col-md-9">
                          <label :for="champ.key" class="form-label">{{champ.libelle}}
                            <span v-if="champ.obligatoire">&nbsp;</span>
                            <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                          </label>
                          <div class="input-group mb-3 has-validation">
                            <input :id="champ.key" v-model="booking.urgenceTelephone" :name="champ.key"
                                  :required="champ.obligatoire"
                                  class="form-control"
                                   :pattern="getPhonePattern(booking.urgenceTelephonePrefix, 'mobi')"
                                   v-maska="getPhoneMaska(booking.urgenceTelephonePrefix, 'mobi')"
                                  type="tel" @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                            <div :id="champ.key + 'Help'" class="form-text">
                              <template v-if="booking.urgenceTelephonePrefix === '0032'">
                                {{ activity?.catalogueTraduction?.formFormatMobileBe || $t('form.formatMobileBe') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '0033'">
                                {{ activity?.catalogueTraduction?.formFormatMobileFr || $t('form.formatMobileFr') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '0031'">
                                {{ activity?.catalogueTraduction?.formFormatMobileNl || $t('form.formatMobileNl') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '0049'">
                                {{ activity?.catalogueTraduction?.formFormatMobileDe || $t('form.formatMobileDe') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '00352'">
                                {{ activity?.catalogueTraduction?.formFormatMobileLu || $t('form.formatMobileLu') }}
                              </template>
                            </div>
                            <div class="invalid-feedback">
                              {{
                                champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                              }}
                              <br v-if="champ.obligatoire" />
                              <template v-if="booking.urgenceTelephonePrefix === '0032'">
                                {{ activity?.catalogueTraduction?.formErreurFormatMobile || $t('form.formErreurFormatMobile') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '0033'">
                                {{ activity?.catalogueTraduction?.formErreurFormatMobileFr || $t('form.formErreurFormatMobileFr') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '0031'">
                                {{ activity?.catalogueTraduction?.formErreurFormatMobileNl || $t('form.formErreurFormatMobileNl') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '0049'">
                                {{ activity?.catalogueTraduction?.formErreurFormatMobileDe || $t('form.formErreurFormatMobileDe') }}
                              </template>
                              <template v-if="booking.urgenceTelephonePrefix === '00352'">
                                {{ activity?.catalogueTraduction?.formErreurFormatMobileLu || $t('form.formErreurFormatMobileLu') }}
                              </template>
                            </div>
                          </div>
                        </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_MOBILE  && !principalAdr"
                      class="row">
                    <div class="col-4 col-md-3">
                      <label :for="champ.key + '_prefix'" class="form-label">
                        {{ activity?.catalogueTraduction?.formTelephonePrefix || $t('form.formTelephonePrefix') }}
                      </label>
                      <select :id="champ.key" v-model="booking.mobilePrefix" :name="champ.key + '_prefix'"
                              :required="champ.obligatoire"
                              class="form-select" @blur="onFormInputBlur(true, $event)">
                        <option selected value="0032">+32</option>
                        <option value="0033">+33</option>
                        <option value="0031">+31</option>
                        <option value="0049">+49</option>
                        <option value="00352">+352</option>
                      </select>
                    </div>
                    <div class="col-8 col-md-9">
                      <label :for="champ.key" class="form-label">{{champ.libelle}}
                        <span v-if="champ.obligatoire">&nbsp;</span>
                        <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                      </label>
                      <div class="input-group mb-3 has-validation">
                        <input :id="champ.key" v-model="booking.mobile" :name="champ.key"
                               :required="champ.obligatoire"
                               class="form-control"
                               :pattern="getPhonePattern(booking.mobilePrefix, 'mobi')"
                               v-maska="getPhoneMaska(booking.mobilePrefix, 'mobi')"
                               type="tel" @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                        <div :id="champ.key + 'Help'" class="form-text">
                          <template v-if="booking.mobilePrefix === '0032'">
                            {{ activity?.catalogueTraduction?.formFormatMobileBe || $t('form.formatMobileBe') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '0033'">
                            {{ activity?.catalogueTraduction?.formFormatMobileFr || $t('form.formatMobileFr') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '0031'">
                            {{ activity?.catalogueTraduction?.formFormatMobileNl || $t('form.formatMobileNl') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '0049'">
                            {{ activity?.catalogueTraduction?.formFormatMobileDe || $t('form.formatMobileDe') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '00352'">
                            {{ activity?.catalogueTraduction?.formFormatMobileLu || $t('form.formatMobileLu') }}
                          </template>
                        </div>
                        <div class="invalid-feedback">
                          {{
                            champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                          }}
                          <br v-if="champ.obligatoire" />
                          <template v-if="booking.mobilePrefix === '0032'">
                            {{ activity?.catalogueTraduction?.formErreurFormatMobile || $t('form.formErreurFormatMobile') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '0033'">
                            {{ activity?.catalogueTraduction?.formErreurFormatMobileFr || $t('form.formErreurFormatMobileFr') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '0031'">
                            {{ activity?.catalogueTraduction?.formErreurFormatMobileNl || $t('form.formErreurFormatMobileNl') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '0049'">
                            {{ activity?.catalogueTraduction?.formErreurFormatMobileDe || $t('form.formErreurFormatMobileDe') }}
                          </template>
                          <template v-if="booking.mobilePrefix === '00352'">
                            {{ activity?.catalogueTraduction?.formErreurFormatMobileLu || $t('form.formErreurFormatMobileLu') }}
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_TEL  && !principalAdr"
                      class="row">
                    <div class="col-4 col-md-3">
                      <label :for="champ.key + '_prefix'" class="form-label">
                        {{ activity?.catalogueTraduction?.formTelephonePrefix || $t('form.formTelephonePrefix') }}
                      </label>
                      <select :id="champ.key" v-model="booking.telephonePrefix" :name="champ.key + '_prefix'"
                              :required="champ.obligatoire"
                              class="form-select" @blur="onFormInputBlur(true, $event)">
                        <option selected value="0032">+32</option>
                        <option value="0033">+33</option>
                        <option value="0031">+31</option>
                        <option value="0049">+49</option>
                        <option value="00352">+352</option>
                      </select>
                    </div>
                    <div class="col-8 col-md-9">
                      <label :for="champ.key" class="form-label">{{champ.libelle}}
                        <span v-if="champ.obligatoire">&nbsp;</span>
                        <i v-if="champ.obligatoire" class="bi bi-asterisk text-danger"></i>
                      </label>
                      <div class="input-group mb-3 has-validation">
                        <input :id="champ.key" v-model="booking.telephone" :name="champ.key"
                               :required="champ.obligatoire"
                               class="form-control"
                               :pattern="getPhonePattern(booking.telephonePrefix, 'tel')"
                               v-maska="getPhoneMaska(booking.telephonePrefix, 'tel')"
                               type="tel" @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                        <div :id="champ.key + 'Help'" class="form-text">
                          <template v-if="booking.telephonePrefix === '0032'">
                            {{ activity?.catalogueTraduction?.formFormatTelephoneBe || $t('form.formFormatTelephoneBe') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '0033'">
                            {{ activity?.catalogueTraduction?.formFormatTelephoneFr || $t('form.formFormatTelephoneFr') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '0031'">
                            {{ activity?.catalogueTraduction?.formFormatTelephoneNl || $t('form.formFormatTelephoneNl') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '0049'">
                            {{ activity?.catalogueTraduction?.formFormatTelephoneDe || $t('form.formFormatTelephoneDe') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '00352'">
                            {{ activity?.catalogueTraduction?.formFormatTelephoneLu || $t('form.formFormatTelephoneLu') }}
                          </template>
                        </div>
                        <div class="invalid-feedback">
                          {{
                            champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                          }}
                          <br v-if="champ.obligatoire" />
                          <template v-if="booking.telephonePrefix === '0032'">
                            {{ activity?.catalogueTraduction?.formErreurFormatTelephoneBe || $t('form.formErreurFormatTelephoneBe') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '0033'">
                            {{ activity?.catalogueTraduction?.formErreurFormatTelephoneFr || $t('form.formErreurFormatTelephoneFr') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '0031'">
                            {{ activity?.catalogueTraduction?.formErreurFormatTelephoneNl || $t('form.formErreurFormatTelephoneNl') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '0049'">
                            {{ activity?.catalogueTraduction?.formErreurFormatTelephoneDe || $t('form.formErreurFormatTelephoneDe') }}
                          </template>
                          <template v-if="booking.telephonePrefix === '00352'">
                            {{ activity?.catalogueTraduction?.formErreurFormatTelephoneLu || $t('form.formErreurFormatTelephoneLu') }}
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.INDIVIDU_ADR_URGENCE"
                      class="form-check form-switch mb-3">
                    <input :id="champ.key" v-model="booking.urgenceIdentique" :name="champ.key"
                           aria-controls="collapseUrgence" aria-expanded="false" checked
                           class="form-check-input" data-bs-target="#collapseUrgence" data-bs-toggle="collapse"
                           role="switch"
                           type="checkbox"
                           @change="handleHeight">
                    <label :for="champ.key" class="form-check-label">{{ activity?.catalogueTraduction?.formAdresseUrgenceIdentique || $t('form.adresse.urgenceIdentique') }}</label>

                    <div id="collapseUrgence" :class="{'show' : !booking.urgenceIdentique}" class="collapse mt-3">
                      <div class="card mb-3">
                        <div class="card-header">{{ champ.libelle }}</div>
                        <div class="card-body row g-3">
                          <div class="col-md-6">
                            <label :for="champ.key + '_prenom'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdressePrenom || $t('form.adresse.prenom')
                              }}</label>
                            <input :id="champ.key + '_prenom'" v-model="booking.urgence.prenom"
                                   :name="champ.key + '_prenom'" class="form-control"
                                   type="text"
                                   @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-6">
                            <label :for="champ.key + '_nom'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseNom || $t('form.adresse.nom')
                              }}</label>
                            <input :id="champ.key + '_nom'" v-model="booking.urgence.nom" :name="champ.key + '_nom'"
                                   class="form-control"
                                   type="text"
                                   @blur="onFormInputBlur(champ.obligatoire, $event)"/>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-6">
                            <label :for="champ.key + '_email'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseEmail || $t('form.adresse.email')
                              }}</label>
                            <div class="input-group">
                              <span class="input-group-text">@</span>
                              <input :id="champ.key + '_email'" v-model="booking.urgence.email"
                                     :name="champ.key + '_email'"
                                     :required="!booking.urgenceIdentique"
                                     class="form-control" type="email"
                                     @blur="onFormInputBlur(true, $event)"/>
                              <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }} et doit être un format d'email
                                valide
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label :for="champ.key + '_tel'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseTel || $t('form.adresse.tel')
                              }}</label>
                            <div class="input-group">
                              <span class="input-group-text">&#9742;</span>
                              <input :id="champ.key + '_tel'" v-model="booking.urgence.tel" :name="champ.key + '_tel'"
                                     class="form-control"
                                     pattern="(^[0-9]{4} ([0-9]{1,3}) ([0-9]{2} )*[0-9]{2}$)|(^[0-9]{4}\s*([0-9]*)|(^0032$)$)"
                                     type="tel" @blur="onFormInputBlur(true, $event)"/>
                              <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formFormatTel || $t('form.formatTel') }}</div>
                              <div class="invalid-feedback">{{
                                  champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') + ', ' + activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label :for="champ.key + '_mobile'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseMobile || $t('form.adresse.mobile')
                              }}</label>
                            <div class="input-group">
                              <span class="input-group-text">&#9742;</span>
                              <input :id="champ.key + '_mobile'" v-model="booking.urgence.mobile"
                                     :name="champ.key + '_mobile'" :required="!booking.urgenceIdentique"
                                     class="form-control"
                                     pattern="(^[0-9]{4} ([0-9]{1,3}) ([0-9]{2} )*[0-9]{2}$)|(^[0-9]{4}\s*([0-9]*)|(^0032$)$)"
                                     type="tel" @blur="onFormInputBlur(true, $event)"/>
                              <div :id="champ.key + 'Help'" class="form-text">{{ activity?.catalogueTraduction?.formFormatMobile || $t('form.formatMobile') }}</div>
                              <div class="invalid-feedback">{{
                                  champ.obligatoire ? (activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') + ', ' + activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')) : activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="col-md-8">
                            <label :for="champ.key + '_adresse'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseAdresse || $t('form.adresse.adresse')
                              }}</label>
                            <input :id="champ.key + '_adresse'" v-model="booking.urgence.rue"
                                   :name="champ.key + '_adresse'"
                                   :required="champ.obligatoire && !booking.urgenceIdentique"
                                   class="form-control" type="text"
                                   @blur="onFormInputBlur(champ.obligatoire && !booking.urgenceIdentique, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-2">
                            <label :for="champ.key + '_numero'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseNumero || $t('form.adresse.numero')
                              }}</label>
                            <input :id="champ.key + '_numero'" v-model="booking.urgence.numero"
                                   :name="champ.key + '_numero'"
                                   :required="champ.obligatoire && !booking.urgenceIdentique"
                                   class="form-control" maxlength="5" type="text"
                                   @blur="onFormInputBlur(champ.obligatoire && !booking.urgenceIdentique, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-2">
                            <label :for="champ.key + '_boite'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseBoite || $t('form.adresse.boite')
                              }}</label>
                            <input :id="champ.key + '_boite'" v-model="booking.urgence.boite"
                                   :name="champ.key + '_boite'"
                                   class="form-control"
                                   maxlength="5" type="text">
                          </div>
                          <div class="col-md-2">
                            <label :for="champ.key + '_cp'" class="form-label">{{ activity?.catalogueTraduction?.formAdresseCp || $t('form.adresse.cp') }}</label>
                            <input :id="champ.key + '_cp'" v-model="booking.urgence.cp"
                                   :name="champ.key + '_cp'"
                                   :required="champ.obligatoire && !booking.urgenceIdentique"
                                   class="form-control" type="number"
                                   @blur="onFormInputBlur(champ.obligatoire && !booking.urgenceIdentique, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-6">
                            <label :for="champ.key + '_ville'" class="form-label">{{
                                activity?.catalogueTraduction?.formAdresseVille || $t('form.adresse.ville')
                              }}</label>
                            <input :id="champ.key + '_ville'" v-model="booking.urgence.ville"
                                   :name="champ.key + '_ville'"
                                   :required="champ.obligatoire && !booking.urgenceIdentique"
                                   class="form-control" type="text"
                                   @blur="onFormInputBlur(champ.obligatoire && !booking.urgenceIdentique, $event)">
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                          <div class="col-md-12">
                            <label :for="champ.key + '_pays'" class="form-label">{{ activity?.catalogueTraduction?.formAdressePays || $t('form.adresse.pays') }}</label>
                            <select :id="champ.key + '_pays'" v-model="booking.urgence.pays"
                                    :name="champ.key + '_pays'"
                                    :required="champ.obligatoire && !booking.urgenceIdentique"
                                    class="form-select"
                                    @blur="onFormInputBlur(champ.obligatoire && !booking.urgenceIdentique, $event)">
                              <option selected value="BE">{{ activity?.catalogueTraduction?.formPaysBelgique || $t('form.pays.belgique') }}</option>
                              <option value="LU">{{ activity?.catalogueTraduction?.formPaysLuxembourg || $t('form.pays.luxembourg') }}</option>
                              <option value="FR">{{ activity?.catalogueTraduction?.formPaysFrance || $t('form.pays.france') }}</option>
                              <option value="DE">{{ activity?.catalogueTraduction?.formPaysAllemagne || $t('form.pays.allemagne') }}</option>
                              <option value="NL">{{ activity?.catalogueTraduction?.formPaysPaysBas || $t('form.pays.paysbas') }}</option>
                            </select>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="champ.key === constants.champs.PERIODES_PLAINE && widgetForm.periodes"
                       class="ns-periodes periodes row card mb-3">
                    <div class="card-header">{{ champ.libelle }}</div>
                    <div class="card-body">
                      <div v-for="(periode) in widgetForm.periodes" :key="periode.id" class="form-check col-xl-6 mb-3">
                        <input :id="periode.id" v-model="booking.periodes.find(p => p.id === periode.id).checked"
                               :disabled="periode.complet && !periode.attente"
                               :name="'periode_' + periode.id"
                               :required="!isValidPeriodeSelection()" :value="periode.id" class="form-check-input"
                               type="checkbox"
                               @change="refreshPrice($event)"/>

                        <label :for="periode.id" class="form-check-label">
                          <div class="card-body-period-column">
                            <p class="card-title">
                              {{ periode.libelle }}&nbsp;{{ activity?.catalogueTraduction?.formPeriodesDu || $t('form.periodes.du') }}&nbsp;{{
                                periode.debut
                              }}&nbsp;{{ activity?.catalogueTraduction?.formPeriodesAu || $t('form.periodes.au') }}&nbsp;{{ periode.fin }}
                            </p>
                            <ul class="prix list-group">
                              <li v-if="periode.complet && periode.attente" class="attente list-group-item">
                                <span class="text-warning fw-bolder">{{ activity?.catalogueTraduction?.formPeriodeComplet || $t('form.periodeComplet') }}&nbsp;
                                <i :title="activity?.catalogueTraduction?.formPeriodeAttente || $t('form.periodeAttente')"
                                   class="bi-info-circle text-warning"
                                   data-bs-placement="top"
                                   data-bs-toggle="tooltip"></i>
                                </span>
                              </li>
                              <li v-else-if="periode.complet" class="complet list-group-item">
                                <span class="text-danger fw-bolder">{{ activity?.catalogueTraduction?.formPeriodeComplet || $t('form.periodeComplet') }}</span>
                              </li>
                              <li v-if="(!periode.complet || periode.attente) && periode.specifique"
                                  class="list-group-item base">
                                <strong>{{ activity?.catalogueTraduction?.activityPrix || $t('activity.prix') }}&nbsp;:&nbsp;</strong>
                                <span class="fw-bold badge bg-secondary">{{ formatPrice(periode.specifique) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                                    getLibelleForPrice(periode)
                                  }}</small></span>
                              </li>
                              <li v-if="activity.reductionMC" class="mc list-group-item">
                                <strong>{{ activity?.catalogueTraduction?.activityReductionMC || $t('activity.reductionMC') }}&nbsp;<span :title="activity?.catalogueTraduction?.activityToolTipReductionMC || $t('activity.toolTipReductionMC')"
                                                                                    class="bi-info-circle"
                                                                                    data-bs-placement="top"
                                                                                    data-bs-toggle="tooltip"></span>&nbsp;:&nbsp;</strong>
                                <span
                                    v-if="periode.specifique && activity.typeTarifMC === constants.inscription.PRIX_PAR_JOUR"
                                    class="fw-bold badge bg-success">{{ formatPrice(activity.reductionMC, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                                    activity?.catalogueTraduction?.activityPrixJour || $t('activity.prixJour')
                                  }}</small></span>
                                <span
                                    v-else-if="periode.specifique && activity.typeTarifMC === constants.inscription.PRIX_PAR_PERIODE"
                                    class="fw-bold badge bg-success">{{ formatPrice(activity.reductionMC, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                                    activity?.catalogueTraduction?.activityPrixSemaine || $t('activity.prixSemaine')
                                  }}</small></span>
                                <span v-else class="fw-bold badge bg-success">{{
                                    formatPrice(activity.reductionMC, true)
                                  }}<small>&nbsp;€</small></span>
                              </li>
                              <li v-if="activity.reductionBIM" class="bim list-group-item">
                                <strong>{{ activity?.catalogueTraduction?.activityReductionBIM || $t('activity.reductionBIM') }}&nbsp;<span :title="activity?.catalogueTraduction?.activityToolTipReductionBim || $t('activity.toolTipReductionBIM')"
                                                                                     class="bi-info-circle"
                                                                                     data-bs-placement="top"
                                                                                     data-bs-toggle="tooltip"></span>&nbsp;:&nbsp;</strong>
                                <span
                                    v-if="periode.specifique && activity.typeTarifBIM === constants.inscription.PRIX_PAR_JOUR"
                                    class="fw-bold badge bg-success">{{ formatPrice(activity.reductionBIM, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                                    activity?.catalogueTraduction?.activityPrixJour || $t('activity.prixJour')
                                  }}</small></span>
                                <span
                                    v-else-if="periode.specifique && activity.typeTarifBIM === constants.inscription.PRIX_PAR_PERIODE"
                                    class="fw-bold badge bg-success">{{ formatPrice(activity.reductionBIM, true) }}<small>&nbsp;€&nbsp;/&nbsp;{{
                                    activity?.catalogueTraduction?.activityPrixSemaine || $t('activity.prixSemaine')
                                  }}</small></span>
                                <span v-else class="fw-bold badge bg-success">{{
                                    formatPrice(activity.reductionBIM, true)
                                  }}<small>&nbsp;€</small></span>
                              </li>
                            </ul>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formPeriodesObligatoire || $t('form.periodes.obligatoire') }}</div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="champ.key === constants.champs.PERIODES_FORMATION && widgetForm.periodes"
                       class="ns-periodes periodes card mb-3">
                    <div class="card-header">{{ champ.libelle }}</div>
                    <div class="card-body">
                      <div v-for="(periode) in widgetForm.periodes" :key="periode.id" class="form-check col-xl-6 mb-3">
                        <input :id="periode.id" v-model="booking.periodes.find(p => p.id === periode.id).checked"
                               :disabled="periode.complet && !periode.attente"
                               :name="'periode_' + periode.id"
                               :required="!isValidPeriodeSelection()" :value="periode.id" class="form-check-input"
                               type="checkbox"
                               @change="refreshPrice($event)"/>

                        <label :for="periode.id" class="form-check-label">
                          <div class="card-body-period-column">
                            <p class="card-title">
                              {{ periode.libelle }}&nbsp;{{ activity?.catalogueTraduction?.formPeriodesDu || $t('form.periodes.du') }}&nbsp;{{
                                periode.debut
                              }}&nbsp;{{ activity?.catalogueTraduction?.formPeriodesAu || $t('form.periodes.au') }}&nbsp;{{ periode.fin }}
                            </p>
                            <ul class="prix list-group">
                              <li v-if="periode.complet && periode.attente" class="attente list-group-item">
                                <span class="text-warning fw-bolder">{{ activity?.catalogueTraduction?.formPeriodeComplet || $t('form.periodeComplet') }}&nbsp;
                                <i :title="activity?.catalogueTraduction?.formPeriodeAttente || $t('form.periodeAttente')"
                                   class="bi-info-circle text-warning"
                                   data-bs-placement="top"
                                   data-bs-toggle="tooltip"></i>
                                </span>
                              </li>
                              <li v-else-if="periode.complet" class="complet list-group-item">
                                <span class="text-danger fw-bolder">{{ activity?.catalogueTraduction?.formPeriodeComplet || $t('form.periodeComplet') }}</span>
                              </li>
                              <li v-if="(!periode.complet || periode.attente) && periode.specifique"
                                  class="list-group-item base">
                                <strong>{{ activity?.catalogueTraduction?.activityPrix || $t('activity.prix') }}&nbsp;:&nbsp;</strong>
                                <span class="badge bg-secondary rounded-pill">{{
                                    formatPrice(periode.specifique)
                                  }}<small>&nbsp;€&nbsp;/&nbsp;{{ getLibelleForPrice(periode) }}</small></span>
                              </li>
                            </ul>
                            <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formPeriodesObligatoire || $t('form.periodes.obligatoire') }}</div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.EMBARQUEMENTS && widgetForm.embarquements"
                      class="card mb-3">
                    <div class="card-header">{{ champ.libelle }}</div>
                    <div class="card-body">
                      <div v-for="embarquement in widgetForm.embarquements" :key="embarquement.id" class="form-check">
                        <input :id="embarquement.id" v-model="booking.embarquement.id" :name="champ.key"
                               :required="champ.obligatoire"
                               :value="embarquement.id" class="form-check-input" type="radio"
                               @change="onEmbarquementChange(embarquement.libelle)"/>
                        <label :for="embarquement.id" class="form-check-label">
                          {{ embarquement.libelle }}
                        </label>
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                    </div>
                  </div>

                  <div
                      v-else-if="champ.key === constants.champs.DEBARQUEMENTS && widgetForm.debarquements"
                      class="card mb-3">
                    <div class="card-header">{{ champ.libelle }}</div>
                    <div class="card-body">
                      <div v-for="debarquement in widgetForm.debarquements" :key="debarquement.id" class="form-check">
                        <input :id="debarquement.id" v-model="booking.debarquement.id" :name="champ.key"
                               :required="champ.obligatoire"
                               :value="debarquement.id" class="form-check-input" type="radio"
                               @change="onDebarquementChange(debarquement.libelle)"/>
                        <label :for="debarquement.id" class="form-check-label">
                          {{ debarquement.libelle }}
                        </label>
                        <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                      </div>
                    </div>
                  </div>

                  <template v-else-if="champ.key === constants.champs.CONTINGENTS">
                    <div v-if="widgetForm.contingents && widgetForm.contingents.length > 0" class="ns-options options-libres card mb-3">
                      <div v-if="widgetForm.contingentsGroupes && Object.entries(widgetForm.contingentsGroupes).some(([groupe, value]) => Array.isArray(value) && value.length > 0)"
                           class="card-header">
                        {{ activity?.catalogueTraduction?.formContingentsLibres || $t('form.contingentsLibres') }}
                      </div>
                      <div v-else class="card-header">{{ champ.libelle }}</div>
                      <div class="card-body">
                        <ul class="list-group-flush">
                          <li v-for="(contingent) in widgetForm.contingents" :key="contingent.id"
                              class="list-group-item">
                            <div class="form-check">
                              <input :id="contingent.id"
                                     v-model="booking.contingents.find(c => c.id === contingent.id).checked"
                                     :disabled="shouldContingentBeDisabled(contingent) || (booking.naissance && activity.validateAge && !validContingents.includes(contingent.id))"
                                     :name="'contingent_' + contingent.id"
                                     :required="contingent.obligatoire"
                                     :value="contingent.id"
                                     class="form-check-input" type="checkbox"
                                     @change="refreshPrice($event); validateBirthDate(); contingentUnselectedWarning = false;"/>
                              <label :for="contingent.id" class="form-check-label">
                                {{ contingent.nom }}&nbsp;
                                <span v-if="contingent.complet && contingent.attente && !shouldContingentBeDisabled(contingent)"
                                      class="text-warning fw-bolder me-1">{{ activity?.catalogueTraduction?.formContingentComplet || $t('form.contingentComplet') }}</span>
                                <template v-if="contingent.complet && contingent.attente && !shouldContingentBeDisabled(contingent)">
                                  <span :title="activity?.catalogueTraduction?.formContingentAttente || $t('form.contingentAttente')"
                                        class="bi-info-circle text-warning me-2"
                                        data-bs-placement="right"
                                        data-bs-toggle="tooltip"></span>
                                </template>
                                <span v-else-if="contingent.complet"
                                      class="text-danger fw-bolder">{{ activity?.catalogueTraduction?.formContingentComplet || $t('form.contingentComplet') }}</span>
                                <span
                                    v-if="(!contingent.complet || contingent.attente) && contingent.montant && contingent.type.intKey === constants.inscription.CONTINGENT_PAYANT"
                                    class="badge bg-secondary rounded-pill">{{ formatPrice(contingent.montant) }}
                                    <small>€{{ $t(getLibelleForTypePaiement(contingent.typePayement?.intKey)) }}</small></span>
                                <span
                                    v-else-if="(!contingent.complet || contingent.attente) && contingent.montant && contingent.type.intKey === constants.inscription.CONTINGENT_REDUCTION"
                                    class="badge bg-success rounded-pill">-&nbsp;{{ formatPrice(contingent.montant) }}
                                    <small>€{{ $t(getLibelleForTypePaiement(contingent.typePayement?.intKey)) }}</small></span>
                              </label>
                              <div class="invalid-age-contingent text-muted ms-4" v-if="(booking.naissance && activity.validateAge && !validContingents.includes(contingent.id))"> {{ activity?.catalogueTraduction?.formContingentNotSelectableMessage || $t('form.contingentNotSelectableMessage') }} </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div v-if="widgetForm.contingentsGroupes && Object.entries(widgetForm.contingentsGroupes).some(([groupe, value]) => Array.isArray(value) && value.length > 0)" class="ns-options">
                      <h3>{{ champ.libelle }}</h3>
                      <div v-for="(groupe, index) in Object.keys(widgetForm.contingentsGroupes)" :key="groupe"
                           class="options-groupe card mb-3">
                        <div v-if="Object.keys(widgetForm.contingentsGroupes).length >= 1" class="card-header">{{
                            groupe
                          }}
                        </div>
                        <div class="card-body">
                          <div v-for="contingent in widgetForm.contingentsGroupes[groupe]" :key="contingent.id"
                               class="form-check">
                            <input :id="contingent.id"
                                   v-model="booking.contingents.find(c => c.id === contingent.id).checked"
                                   :disabled="shouldContingentBeDisabled(contingent) || (booking.naissance && activity.validateAge && !validContingentsGroupes.includes(contingent.id))"
                                   :name="index"
                                   :value="true"
                                   class="form-check-input"
                                   required type="radio"
                                   @change="refreshPrice($event); validateBirthDate(); validateContingents()"
                                   @blur="onFormInputBlur(champ.obligatoire, $event);"/>
                            <label :for="contingent.id" class="form-check-label">
                              {{ contingent.nom }}&nbsp;
                              <span v-if="contingent.complet && contingent.attente && !shouldContingentBeDisabled(contingent)" class="text-warning fw-bolder me-1">{{
                                  activity?.catalogueTraduction?.formContingentComplet || $t('form.contingentComplet')
                                }}</span>
                              <template v-if="contingent.complet && contingent.attente && !shouldContingentBeDisabled(contingent)">
                                <span :title="activity?.catalogueTraduction?.formContingentAttente || $t('form.contingentAttente')"
                                      class="bi-info-circle text-warning me-2"
                                      data-bs-placement="right"
                                      data-bs-toggle="tooltip"></span>
                              </template>
                              <span v-else-if="contingent.complet"
                                    class="text-danger fw-bolder">{{ activity?.catalogueTraduction?.formContingentComplet || $t('form.contingentComplet') }}</span>
                              <span
                                  v-if="(!contingent.complet || contingent.attente) && contingent.montant && contingent.type.intKey === constants.inscription.CONTINGENT_PAYANT"
                                  class="badge bg-secondary rounded-pill">{{ formatPrice(contingent.montant) }}
                                    <small>€{{ $t(getLibelleForTypePaiement(contingent.typePayement?.intKey)) }}</small></span>
                              <span
                                  v-else-if="(!contingent.complet || contingent.attente) && contingent.montant && contingent.type.intKey === constants.inscription.CONTINGENT_REDUCTION"
                                  class="badge bg-success rounded-pill">-&nbsp;{{ formatPrice(contingent.montant) }}
                                    <small>€{{ $t(getLibelleForTypePaiement(contingent.typePayement?.intKey)) }}</small></span>
                            </label>
                            <div class="invalid-feedback"> {{ activity?.catalogueTraduction?.formOptionsObligatoire || $t('form.options.obligatoire') }} </div>
                            <div class="invalid-age-contingent-groupes text-muted ms-4" v-if="(booking.naissance && activity.validateAge && !validContingentsGroupes.includes(contingent.id))"> {{ activity?.catalogueTraduction?.formContingentNotSelectableMessage || $t('form.contingentNotSelectableMessage') }} </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="booking.naissance && activity.validateAge && contingentsGroupesValidationError"
                         class="text-danger fw-bolder">
                      {{ activity?.catalogueTraduction?.formAgeConstraintValidationerror || $t('form.ageConstraintValidationError') }}
                    </div>
                  </template>

                  <div v-else-if="champ.key === constants.champs.QUESTIONS && widgetForm.questions"
                       class="ns-options questions card mb-3">
                    <div class="card-header">{{ champ.libelle }}</div>
                    <div class="card-body">
                      <template v-for="(question) in widgetForm.questions" :key="question.id">
                        <label :for="'question_' + question.id" class="form-label">
                          {{ question.texte }}
                          <span v-if="question.obligatoire">&nbsp;</span>
                          <i v-if="question.obligatoire" class="bi bi-asterisk text-danger"></i>
                        </label>
                        <div class="input-group mb-3 has-validation">
                          <input v-if="question.type === constants.inscription.QUESTION_TEXTE"
                                 :id="'question_' + question.id"
                                 v-model="booking.questions.find(q => q.id === question.id).valeur"
                                 :name="'question_' + question.id" :required="question.obligatoire"
                                 class="form-control" type="text"
                                 @blur="onFormInputBlur(question.obligatoire, $event)"/>

                          <input v-else-if="question.type === constants.inscription.QUESTION_NOMBRE"
                                 :id="'question_' + question.id"
                                 v-model="booking.questions.find(q => q.id === question.id).valeur"
                                 :name="'question_' + question.id" :required="question.obligatoire"
                                 class="form-control" type="number"
                                 @blur="onFormInputBlur(question.obligatoire, $event)"/>

                          <select v-else-if="question.type === constants.inscription.QUESTION_LISTE"
                                  :id="'question_' + question.id"
                                  v-model="booking.questions.find(q => q.id === question.id).valeur"
                                  :name="'question_' + question.id" :required="question.obligatoire"
                                  class="form-select"
                                  @blur="onFormInputBlur(question.obligatoire, $event)">
                            <option selected value=""></option>
                            <option v-for="(reponse , index) in (question.valeurs?.split(';'))" :key="index"
                                    :value="reponse">{{ reponse.toUpperCase() }}
                            </option>
                          </select>

                          <template v-else-if="question.type === constants.inscription.QUESTION_MULTIPLE">
                            <div v-for="(reponse , index) in (question.valeurs?.split(';'))" :key="index"
                                 class="form-check me-2">
                              <input :id="'reponse_' + index"
                                     v-model="booking.questions.find(q => q.id === question.id).valeurs"
                                     :aria-describedby="question.id+'_Help'"
                                     :name="'question_' + question.id"
                                     :required="question.obligatoire && !isValidQuestionSelection(question)"
                                     :value="reponse" class="form-check-input" type="checkbox"
                                     @change="onMultipleReponsesChange(booking.questions.find(q => q.id === question.id))"/>
                              <label :for="'reponse_' + index" class="form-check-label ms-1">
                                {{ reponse }}
                              </label>
                              <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formConditions || $t('form.conditions') }}</div>
                            </div>
                          </template>
                          <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>

              <!-- Ajout du champ de collecte obligatoire du NRN sous conditions -->
              <div
                  v-if="activity.validationAutomatique && step === (validationStep - 1) && activity.prixBaseActivite > 0 && activity.reductionMC && booking.places === 1"
                  class="ns-options mc-avantage card mb-3">
                <div class="card-header text-white bg-success">{{ activity?.catalogueTraduction?.formAvantagesMc || $t('form.avantagesMC') }}</div>
                <div class="card-body">
                  <div class="form-check form-switch mb-3">
                    <input id="membre-switcher-id" v-model="booking.avantages" class="form-check-input"
                           name="membre-switcher"
                           role="switch"
                           type="checkbox"
                           @change="handleChangeAvantages($event)">
                    <label class="form-check-label"
                           for="membre-switcher-id" v-html="activity?.catalogueTraduction?.formAvantagesSwicthLabel"></label>
                  </div>

                  <div class="champ" v-if="booking.avantages">
                    <label class="form-label" for="nrn-id">{{ activity?.catalogueTraduction?.formNrn || $t('form.nrn') }}&nbsp;<i
                        class="bi bi-asterisk text-danger"></i></label>
                    <div class="input-group mb-3 has-validation">
                      <input id="nrn-id" v-model="booking.nrn" v-maska="['## ## ## ###-##', '## ## ## ###-##']"
                             :placeholder="activity?.catalogueTraduction?.formFormatNrn || $t('form.formatNrn')"
                             aria-describedby="nrnHelp"
                             class="form-control mw-300" name="nrn"
                             pattern="^([0-9]{2} ){3}([0-9]{3}-){1}[0-9]{2}$"
                             required
                             type="text"
                             @blur="onNrnInputBlur(true, $event)"/>
                      <div id="nrnHelp" class="form-text">{{ activity?.catalogueTraduction?.formTrouverNrn || $t('form.trouverNrn') }}</div>
                      <div class="invalid-feedback">{{
                          activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') + ', ' + activity?.catalogueTraduction?.formFormatInvalide || $t('form.formatInvalide')
                        }}
                      </div>
                    </div>
                  </div>
                  <div v-if="!booking.avantages && activity.validationAutomatique" v-html="activity.professionnel" />

                </div>
              </div>
            </div>
          </template>

          <template v-if="step === validationStep">
            <BookingSummary :type-activite="widgetForm.typeActivite" leave="inModal" :activity="activity" :catalogueTraduction="activity?.catalogueTraduction"/>

            <template v-if="widgetForm.documents && widgetForm.documents.length > 0">
              <div v-for="doc in widgetForm.documents" :key="doc.id" class="form-file mt-3">
                <strong class="h5">{{ doc.nom }}
                  <span v-if="doc.obligatoire">&nbsp;</span><i v-if="doc.obligatoire"
                                                               class="bi bi-asterisk text-danger"></i>
                </strong>

                <div class="has-validation">
                  <div :class="(booking.documents.findIndex(item => item.id === doc.id) > -1) ? 'was-validated' : ''"
                       class="input-group"
                       @dragover.prevent
                       @drop.prevent="onFileDrop(doc, $event)">

                    <input :id="doc.id" :name="'fichier_' + doc.id"
                           :required="doc.obligatoire && (booking.documents.findIndex(item => item.id === doc.id) < 0)"
                           accept=".pdf,.doc,.docx" class="form-control" type="file"
                           @change="onFileInputChange(doc, $event)">

                    <label :for="doc.id" class="form-label">
                        <span v-if="files.findIndex(item => item.id === doc.id) > -1" class="form-file-label">
                          {{ files.find(item => item.id === doc.id)?.file?.name }}
                        </span>
                      <span v-else class="form-file-label">{{ activity?.catalogueTraduction?.formDeposerDocument || $t('form.deposerDocument') }}</span>
                    </label>

                    <div class="invalid-feedback">{{ activity?.catalogueTraduction?.formObligatoire || $t('form.obligatoire') }}</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="booking.conditions && booking.conditions.length > 0">
              <div v-for="optin in booking.conditions" :key="optin.id" class="form-check mt-3 mb-3">
                <input :id="optin.id" :name="'optin_' + optin.id"
                       :required="optin.obligatoire" aria-describedby="optinHelp" class="form-check-input"
                       type="checkbox"
                       @change="onChangeOptin(optin.id, $event.target.checked)"/>
                <label :for="optin.id" class="form-check-label fw-bolder">
                  <a v-if="optin.url" id="optinHelp" :href="optin.url" :title="optin.mentionWeb || optin.nom"
                     class="form-text"
                     target="_blank">
                    {{ optin.mentionWeb || optin.nom }}&nbsp;<i v-if="optin.obligatoire"
                                                                class="bi bi-asterisk text-danger"></i>
                  </a>
                  <span v-else class="form-text">{{ optin.mentionWeb || optin.nom }}&nbsp;<i v-if="optin.obligatoire"
                                                                                             class="bi bi-asterisk text-danger"></i></span>
                </label>
                <div class="invalid-feedback">{{
                    activity?.catalogueTraduction?.formConditions || $t('form.conditions')
                  }}
                </div>
              </div>
            </template>
          </template>

          <div v-if="specificMessage && specificMessage.length > 0 && constraintError" class="alert alert-danger mt-5 error-message"
              role="alert" v-html="specificMessage"></div>

          <div class="buttons-area mt-5">
            <router-link v-if="step === startStep"
                         :to="{ name: 'Activity', query: { catalogue : catalogueId, activity: activity.id}}"
                         class="btn btn-lg btn-outline-info me-3">
              <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z"
                      fill="black" fill-rule="evenodd"/>
              </svg>
              {{ activity?.catalogueTraduction?.formBtnRevenirActivite || $t('form.btnRevenirActivite') }}
            </router-link>

            <button v-else-if="step > startStep && step <= validationStep"
                    :disabled="submiting" class="btn btn-lg btn-outline-secondary me-3" type="button"
                    @click="prevStep">
              <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z"
                      fill="black" fill-rule="evenodd"/>
              </svg>
              {{ activity?.catalogueTraduction?.formBtnPrecedent || $t('form.btnPrecedent') }}
              <span v-if="submiting" class="spinner-border spinner-border-sm text-light" role="status"></span>
            </button>

            <button v-if="step < validationStep" :disabled="submiting"
                    class="btn btn-lg btn-secondary" type="button" @click="nextStep($event)">
              {{ activity?.catalogueTraduction?.formBtnSuivant || $t('form.btnSuivant') }}
              <span v-if="submiting" class="spinner-border spinner-border-sm text-light" role="status"></span>
            </button>

            <button v-if="step === validationStep" :disabled="submiting"
                    class="btn btn-lg btn-success" type="submit"
                    @click="activity.validationAutomatique && !activity.inscriptionListeAttentePossible && booking.prix > 0 && !activity.payantSurPlace && !hasCompleteContingentChecked() ? doPayment() : nextStep($event)">
              <span
                  v-if="activity.validationAutomatique && booking.prix > 0 && !activity.inscriptionListeAttentePossible && !activity.payantSurPlace && !hasCompleteContingentChecked()">{{
                  activity?.catalogueTraduction?.formBtnPayerEnLigne || $t('form.btnPayerEnLigne')
                }}</span>
              <span v-else-if="hasCompleteContingentChecked() || (!activity?.inscriptionPossible && activity?.inscriptionListeAttentePossible)">{{ activity?.catalogueTraduction?.formBtnInscriptionListeAttente || $t('form.formBtnInscriptionListeAttente') }}</span>
              <span v-else>{{ activity?.catalogueTraduction?.formBtnInscription || $t('form.btnInscription') }}</span>
              <span v-if="submiting" class="spinner-border spinner-border-sm text-light" role="status"></span>
            </button>

            <div class="infoActivitePayante" v-if="activity.validationAutomatique && !activity.inscriptionListeAttentePossible && step === validationStep && booking.prix > 0 && !activity.payantSurPlace" v-html="activity.activitePayante" />
          </div>
        </form>

        <!--Message succes -->
        <div v-if="!viewProcessInscriptionAlternatif && validated && widgetForm.dernierePage && step === endStep" ref="refHeightConfirm">

          <div v-if="activity.messageConfirmation && activity.validationAutomatique && !activity.inscriptionListeAttentePossible && booking.prix > 0 && !activity.payantSurPlace" class="alert alert-success mt-5 confirmation-message"
               role="alert" v-html="activity.messageConfirmation"></div>

          <div v-else class="alert alert-success mt-5 confirmation-message" role="alert"
               v-html="widgetForm.dernierePage"></div>

          <p class="mt-5">
            <router-link :to="{ name: 'Activity', query: { catalogue : catalogueId, activity: activity.id}}"
                         class="btn btn-lg btn-outline-info me-3">
              <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z"
                      fill="black" fill-rule="evenodd"/>
              </svg>
              {{ activity?.catalogueTraduction?.formBtnRevenirActivite || $t('form.btnRevenirActivite') }}
            </router-link>

            <router-link :to="{ name: 'Catalogue', query: { catalogue : catalogueId }}"
                         class="btn btn-lg btn-outline-warning">
              {{ activity?.catalogueTraduction?.activityBtnRevenirCatalogue || $t('activity.btnRevenirCatalogue') }}
            </router-link>
          </p>
        </div>
        <!--Message erreur -->
        <div v-else-if="!validated && bookingError && modalMessage" ref="refHeightConfirm">
          <div class="alert alert-danger mt-5 error-message" role="alert" v-html="modalMessage"></div>

          <p class="mt-5">
            <router-link :to="{ name: 'Activity', query: { catalogue : catalogueId, activity: activity.id}}"
                         class="btn btn-lg btn-outline-info me-3">
              <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z"
                      fill="black" fill-rule="evenodd"/>
              </svg>
              {{ activity?.catalogueTraduction?.formBtnRevenirActivite || $t('form.btnRevenirActivite') }}
            </router-link>

            <router-link :to="{ name: 'Catalogue', query: { catalogue : catalogueId }}"
                         class="btn btn-lg btn-outline-warning">
              {{ activity?.catalogueTraduction?.activityBtnRevenirCatalogue || $t('activity.btnRevenirCatalogue') }}
            </router-link>
          </p>
        </div>
        <div v-else-if="!viewProcessInscriptionAlternatif && !validated && bookingError && step === validationStep" ref="refHeightConfirm">

          <div v-if="specificMessage && specificMessage === 'ALREADY_BOOKED'"
               class="alert alert-danger mt-5 error-message"
               role="alert"
               v-html="activity?.catalogueTraduction?.formErreurDejaInscrit || $t('form.erreurDejaInscrit')"></div>

          <div v-else-if="specificMessage && specificMessage === 'NO_PLACES'"
               class="alert alert-danger mt-5 error-message"
               role="alert"
               v-html="activity?.catalogueTraduction?.activityInscriptionImpossible || $t('activity.inscriptionImpossible')"></div>

          <div v-else-if="specificMessage && specificMessage.length > 0" class="alert alert-danger mt-5 error-message"
               role="alert" v-html="specificMessage"></div>

          <div v-else-if="activity.validationAutomatique && activity.messageErreur"
               class="alert alert-danger mt-5 confirmation-message"
               role="alert" v-html="activity.messageErreur"></div>

          <div v-if="widgetForm.formWebModSimple === 'true'" class="mt-3">
            <a class="link" @click="changeInscriptionAlternatif">{{
                activity?.catalogueTraduction?.formLienInscriptionAlternative || $t('form.lienInscriptionAlternative')
              }}</a>
          </div>

          <p class="mt-5">
            <router-link :to="{ name: 'Activity', query: { catalogue : catalogueId, activity: activity.id}}"
                         class="btn btn-lg btn-outline-info me-3">
              <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M16 7.5H3.83L9.42 1.91L8 0.5L0 8.5L8 16.5L9.41 15.09L3.83 9.5H16V7.5Z"
                      fill="black" fill-rule="evenodd"/>
              </svg>
              {{ activity?.catalogueTraduction?.formBtnRevenirActivite || $t('form.btnRevenirActivite') }}
            </router-link>

            <router-link :to="{ name: 'Catalogue', query: { catalogue : catalogueId }}"
                         class="btn btn-lg btn-outline-warning">
              {{ activity?.catalogueTraduction?.activityBtnRevenirCatalogue || $t('activity.btnRevenirCatalogue') }}
            </router-link>
          </p>
        </div>
      </div>
      <div ref="refHeightBox" class="col-lg-4">

        <div class="activiteInfos card">
          <div class="card-body">
            <ActivityInfos :activity="activity" show-title="true" :catalogueTraduction="activity?.catalogueTraduction"/>
          </div>
        </div>

        <div v-if="booking.prix
            && booking.prix > 0
            && step < validationStep"
             class="alert alert-secondary mt-3" role="alert">
          <p>
            <i class="bi-basket"></i>&nbsp;
            <strong>{{ activity?.catalogueTraduction?.formPrixTotal || $t('form.prixTotal') }}&nbsp;:&nbsp;</strong>
            <span class="fw-bold badge bg-secondary">{{ formatPrice(booking.prix) }}<small>&nbsp;€</small></span>
          </p>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import ActivityInfos from "@/components/ActivityInfos";
import axios from "axios";
import constants from "@/constants";
import {computed, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import BookingSummary from "@/components/BookingSummary";
import {onBeforeRouteLeave} from "vue-router";
import {formatPrice, useTooltips} from "@/utils";
import router from "@/router";
import Select2 from 'vue3-select2-component';
import {differenceInYears, parse} from 'date-fns'

export default {
  name: "Form",
  components: {BookingSummary, ActivityInfos, Select2},
  props: ['activityId', 'id', 'catalogueId'],
  setup(props) {
    const loading = ref(true);
    const widgetForm = ref(null);
    const hasError = ref(false);
    const store = useStore();
    const activity = ref(store.getters.getActivity);
    const submiting = ref(false);
    const submited = ref(false);
    const validated = ref(false);
    const booking = ref({
      id: 0,
      contenuPromotionnel: props.activityId,
      activite: 0,
      prix: Number(0.00),
      nom: null,
      prenom: null,
      naissance: null,
      sexe: null,
      email: null,
      nrn: null,
      langue: null,
      nationalite: null,
      telephonePrefix: '0032',
      telephone: null,
      mobilePrefix: '0032',
      mobile: null,
      remarquesAdmin: null,
      remarquesPeda: null,
      places: 1,
      adresse: {
        prenom: null,
        nom: null,
        email: null,
        telPrefix: '0032',
        tel: null,
        mobilePrefix: '0032',
        mobile: null,
        rue: null,
        numero: null,
        boite: null,
        ville: null,
        cp: null,
        pays: 'BE',
        bosa: null,
      },
      facturationIdentique: false,
      facturation: {
        prenom: null,
        nom: null,
        email: null,
        tel: null,
        mobile: null,
        rue: null,
        numero: null,
        boite: null,
        ville: null,
        cp: null,
        pays: 'BE',
        bosa: null,
      },
      urgenceTelephonePrefix: '0032',
      urgenceTelephone: null,
      urgenceNom: null,
      urgencePrenom: null,
      urgenceIdentique: true,
      urgence: {
        prenom: null,
        nom: null,
        email: null,
        tel: null,
        mobile: null,
        rue: null,
        numero: null,
        boite: null,
        ville: null,
        cp: null,
        pays: 'BE',
      },
      periodes: [],
      questions: [],
      contingents: [],
      documents: [],
      embarquement: {
        id: null,
        texte: null,
      },
      debarquement: {
        id: null,
        texte: null,
      },
      conditions: [],
      mc: false,
      avantages: false,
      hostedCheckoutId: null,
      reference: null,
    });
    const form = ref(null);
    const top = ref(null);
    const periodeChecked = ref(false);
    const step = ref(1);
    const files = ref([]);
    const modalMessage = ref(null);
    const inModal = ref(false);
    const modalHeaderClasses = ref(null);
    const btnModal = ref(null);
    const modalRouteBtn = ref(null);
    const widgetURL = process.env.VUE_APP_WIDGET_API_SERVER;
    const startStep = ref(1);
    const validationStep = ref(0);
    const endStep = ref(0);
    const validedStep = ref(0);
    const progress = ref(0);
    const progressStep = ref(0);
    const refHeight = ref(null);
    const refHeightCover = ref(null);
    const refHeightProgress = ref(null);
    const refHeightBox = ref(null);
    const refHeightConfirm = ref(null);
    const bookingError = ref(false);
    const constraintError = ref(false);
    const birthdateValidationError = ref(false);
    const contingentUnselectedWarning = ref(false);
    const birthdateFormStep = ref(0);
    const contingentGroupesFormStep = ref(0);

    const facturationAdrNom = ref(null);
    const facturationAdrPrenom = ref(null);
    const principalAdrNom = ref(null);
    const principalAdrPrenom = ref(null);

    const principalTelephone = ref(null);
    const principalGSM = ref(null);
    const principalMail = ref(null);
    const principalAdr = ref(null);

    const localities = ref([]);
    const streets = ref([]);
    const streetsFact = ref([]);
    const selectedLocality = ref('');
    const selectedFactLocality = ref('');
    const containerCp = ref(null);
    const containerCpFact = ref(null);
    const containerStreet = ref(null);
    const containerStreetFact = ref(null);
    const redirectToPayement = ref(false)
    const confirmPayment = ref(false)
    const paymentConfirmed = ref(false)
    const viewProcessInscriptionAlternatif = ref(false);
    const specificMessage = ref('');
    const loadingStreets = ref(false);
    const loadingFactStreets = ref(false);

    const preventNav = (e) => {
      if (!bookingError.value && !validated.value && !redirectToPayement.value) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    onBeforeMount(() => {
      addEventListener("beforeunload", preventNav);
      addEventListener("resize", handleHeight, {passive: true});

      if (sessionStorage?.getItem('selectedLocality')) {
        selectedLocality.value = sessionStorage.getItem('selectedLocality')
      }
    });

    onBeforeUnmount(() => {
      removeEventListener("beforeunload", preventNav);
      removeEventListener("resize", handleHeight);
    });

    onBeforeRouteLeave((to, from, next) => {
      if (!bookingError.value && !validated.value && !redirectToPayement.value) {
        if (!window.confirm(activity?.value.catalogueTraduction?.formConfirmationQuitterPage || "Quitter la page et annuler l'inscription?"))
          return;
      }
      next();
    });

    watch(step, async () => {

      store.commit('updateBooking', booking.value);

      let curValidedStep = validedStep.value;

      if (step.value > validedStep.value) {
        validedStep.value = step.value - 1;
        if (validedStep.value !== curValidedStep) {
          progress.value += progressStep.value;
          sessionStorage?.setItem('validedStep', validedStep.value.toString());
          sessionStorage?.setItem('progress', progress.value.toString());
        }
      }

      sessionStorage?.setItem('step', step.value.toString());
      sessionStorage?.setItem('booking', JSON.stringify(booking.value));

      if (step.value === endStep.value && !confirmPayment.value) {
        await submitBooking();
      }
      else if(step.value === endStep.value) {
        validated.value = true;
        bookingError.value = false;
        sessionStorage.clear();
      }

      await handleHeight();
    });

    onMounted(async () => {
      await axios
          .get(process.env.VUE_APP_WIDGET_API_ROOT + '/activity-infos' + '/' + props.activityId + "?catalogueId=" + props.catalogueId)
          .then(response => {
            store.commit('updateActivity', response.data);
            activity.value = store.getters.getActivity;
          })
          .catch(error => {
            console.error('Activity infos error:', error);
          });

      booking.value.prix = activity.value.prixBaseActivite
          ? parseFloat(activity.value.prixBaseActivite)
          : Number(0.00);

      if (sessionStorage?.getItem('step'))
        step.value = parseInt(sessionStorage.getItem('step'));
      if (sessionStorage?.getItem('validedStep'))
        validedStep.value = parseInt(sessionStorage.getItem('validedStep'));
      if (sessionStorage?.getItem('progress'))
        progress.value = parseInt(sessionStorage.getItem('progress'));
      if (sessionStorage?.getItem('booking'))
        booking.value = JSON.parse(sessionStorage.getItem('booking'));

      if (props.id > 0 && activity.value && activity.value.activite && activity.value.actif
          && (activity.value.inscriptionPossible || activity.value.inscriptionListeAttentePossible)) {
        await axios
            .get(process.env.VUE_APP_WIDGET_API_ROOT + '/form' + '/' + activity.value.activite + '/' + activity.value.id + '/' + props.id)
            .then(response => {
              widgetForm.value = response.data;
              validationStep.value = widgetForm.value.etapes?.length;
              endStep.value = widgetForm.value.etapes?.length + 1;
              if (validationStep.value > 0)
                progressStep.value = 100 / validationStep.value;

              for (const etape of widgetForm.value.etapes) {
                if (!facturationAdrNom.value)
                  facturationAdrNom.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_ADR_FACTURATION_NOM);
                if (!facturationAdrPrenom.value)
                  facturationAdrPrenom.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_ADR_FACTURATION_PRENOM);
                if (!principalAdrNom.value)
                  principalAdrNom.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_ADR_CONTACT_NOM);
                if (!principalAdrPrenom.value)
                  principalAdrPrenom.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_ADR_CONTACT_PRENOM);

                if (!principalTelephone.value)
                  principalTelephone.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_TEL);
                if (!principalGSM.value)
                  principalGSM.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_MOBILE);
                if (!principalMail.value)
                  principalMail.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_EMAIL);
                if (!principalAdr.value)
                  principalAdr.value = etape.champs.find(champ => champ.key === constants.champs.INDIVIDU_ADR_PRINCIPALE);

                for (const champ of etape.champs) {
                  if (champ.key === constants.champs.INDIVIDU_NAISSANCE) {
                    birthdateFormStep.value = etape.numero;
                  }
                  if (champ.key === constants.champs.CONTINGENTS) {
                    contingentGroupesFormStep.value = etape.numero;
                  }
                }
              }
              booking.value.mc = null;
            })
            .catch(error => {
              console.error('Form error:', error);
              hasError.value = true;
            })
            .finally(() => {
              loading.value = false;
              if (widgetForm.value.periodes && widgetForm.value.periodes.length > 0) {
                widgetForm.value.periodes.forEach(periode => {
                  let p = {
                    id: periode.id,
                    texte: periode.libelle + ' (' + periode.debut + ' - ' + periode.fin + ')',
                    prix: periode.specifique,
                    checked: false,
                    garderie: false,
                    prixGarderie: periode.garderie,
                    transport: false,
                    prixTransport: periode.transport,
                    nbJours: periode.nbJours,
                  }
                  if (booking.value.periodes.findIndex(item => item.id === p.id) < 0)
                    booking.value.periodes.push(p);
                });
              }

              if (widgetForm.value.contingents?.length > 0) {
                widgetForm.value.contingents.forEach(contingent => {
                  let c = {
                    id: contingent.id,
                    texte: contingent.nom,
                    type: contingent.type?.intKey,
                    typePaiement: contingent.typePayement?.intKey,
                    prix: contingent.montant,
                    groupe: false,
                    checked: false,
                  }
                  if (booking.value.contingents.findIndex(item => item.id === c.id) < 0)
                    booking.value.contingents.push(c);
                });
              }

              if (widgetForm.value.contingentsGroupes) {
                let indexGrp = 0;
                Object.keys(widgetForm.value.contingentsGroupes).forEach(groupe => {
                  widgetForm.value.contingentsGroupes[groupe].forEach(contingent => {
                    let c = {
                      id: contingent.id,
                      texte: contingent.nom,
                      type: contingent.type?.intKey,
                      typePaiement: contingent.typePayement?.intKey,
                      prix: contingent.montant,
                      groupe: indexGrp,
                      checked: false,
                    }
                    if (booking.value.contingents.findIndex(item => item.id === c.id) < 0)
                      booking.value.contingents.push(c);
                  });
                  indexGrp++;
                });
              }

              if (widgetForm.value.questions && widgetForm.value.questions.length > 0) {
                widgetForm.value.questions.forEach(question => {
                  let q = {
                    id: question.id,
                    texte: question.texte,
                    valeur: null,
                    valeurs: [],
                  }
                  if (booking.value.questions.findIndex(item => item.id === q.id) < 0)
                    booking.value.questions.push(q);
                });
              }

              if (widgetForm.value.optins && widgetForm.value.optins.length > 0) {
                widgetForm.value.optins.forEach(optin => {
                  let o = {
                    id: optin.id,
                    obligatoire: optin.obligatoire,
                    url : optin.url,
                    mentionWeb : optin.mentionWeb,
                    nom : optin.nom,
                    checked: false,
                  }
                  if (booking.value.conditions.findIndex(item => item.id === o.id) < 0)
                    booking.value.conditions.push(o);
                });
              }

              if (widgetForm.value.conditions && widgetForm.value.conditions.length > 0) {
                widgetForm.value.conditions.forEach(condition => {
                  let c = {
                    id: condition.id,
                    obligatoire: condition.obligatoire,
                    url : condition.url,
                    mentionWeb : condition.mentionWeb,
                    nom : condition.nom,
                    checked: false,
                  }
                  if (booking.value.conditions.findIndex(item => item.id === c.id) < 0)
                    booking.value.conditions.push(c);
                });
              }

              refreshPrice();
            });
      } else {
        loading.value = false;
        hasError.value = true;
      }

      await axios
          .get(process.env.VUE_APP_WIDGET_API_ROOT + '/search/localities')
          .then(response => {
            localities.value = response.data;
          })
          .catch(error => {
            console.error('getAllLocalities error:', error);
          });

      // hostedCheckoutId check
      const hostedCheckoutId = router.currentRoute?.value?.query?.hostedCheckoutId;
      confirmPayment.value = hostedCheckoutId?.length > 0;

      // verify payment status
      if (confirmPayment.value && booking.value.prix > 0 && step.value === (endStep.value - 1)) {

        bookingError.value = false;
        await axios
            .get(process.env.VUE_APP_WIDGET_API_ROOT + '/payment/status/' + hostedCheckoutId)
            .then(response => {
              paymentConfirmed.value = response.data?.status !== 'CANCELLED' &&
                  response.data?.status !== 'REJECTED' &&
                  response.data?.status !== 'REJECTED_CAPTURE' &&
                  response.data?.status !== 'REVERSED'
              if (paymentConfirmed.value) {
                // confirm booking payment if pending or captured
                nextStep()
              } else {
                bookingError.value = true;
              }
            })
            .catch(error => {
              paymentConfirmed.value = false
              bookingError.value = true;
              console.error('confirmPayment error:', error);
            })
            .finally(() => {
              loading.value = false;
            });
      }

      await handleHeight();
      scrollToTop();
    });

    const scrollToTop = () => {
      if (refHeightCover.value)
        refHeightCover.value?.scrollIntoView({behavior: 'smooth'});
      else
        refHeightProgress.value?.scrollIntoView({behavior: 'smooth'});
    }

    const handleHeight = async () => {
      let height = 0;

      await nextTick();

      if (refHeight.value)
        height += refHeight.value?.offsetHeight;
      if (refHeightCover.value)
        height += refHeightCover.value?.offsetHeight;
      if (refHeightProgress.value)
        height += refHeightProgress.value?.offsetHeight;
      if (top.value)
        height += top.value?.offsetHeight;
      if (refHeightConfirm.value)
        height += refHeightConfirm.value?.offsetHeight;
      if (refHeightBox.value && height < refHeightBox.value?.offsetHeight)
        height += refHeightBox.value?.offsetHeight;

      height += 50;

      await useTooltips();

      window.parent.postMessage({frameHeight: height}, '*');
    };

    const onFormInputBlur = (validate, e) => {
      if (validate) {
        let input = e.target.parentElement;
        input.classList.add('was-validated');
        handleHeight();
      }
    }

    const onFormInputPhoneBlur = (e) => {
      let input = e.target.parentElement;
      input.classList.add('was-validated');
      handleHeight();
    }

    const getPhoneMaska = (prefix, type) => {
      if(type === 'tel') {
        switch(prefix) {
          case '0032' : return ['# ## ## ##', '## ## ## ##'];
          case '0033' : return '# ## ## ## ##';
          case '0031' : return '## ### ####';
          case '0049' : return '#############';
          case '00352' : return '## ## ## ##';
          default : return '';
        }
      }else {
        switch(prefix) {
          case '0032' : return '### ## ## ##';
          case '0033' : return '# ## ## ## ##';
          case '0031' : return '# ### ### ##';
          case '0049' : return '### ### #####';
          case '00352' : return '### ### ###';
          default : return '';
        }
      }
    }

    const getPhonePattern = (prefix, type) => {
      if(type === 'tel') {
        switch(prefix) {
          case '0032' : return '^(?:\\d{2}|\\d{1})\\s\\d{2}\\s\\d{2}\\s\\d{2}$';
          case '0033' : return '^\\d{1}\\s\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$';
          case '0031' : return '^\\d{2}\\s\\d{3}\\s\\d{4}$';
          case '0049' : return '^[1-9][0-9]{1,4}[0-9]{3,8}$';
          case '00352' : return '^\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$';
          default : return '';
        }
      }else {
        switch(prefix) {
          case '0032' : return '^4\\d{2}\\s\\d{2}\\s\\d{2}\\s\\d{2}$';
          case '0033' : return '^[67](?:\\s\\d{2}){4}$';
          case '0031' : return '^6\\s\\d{3}\\s\\d{3}\\s\\d{2}$';
          case '0049' : return '^1[5-7]\\d\\s\\d{3}\\s\\d{4}$';
          case '00352' : return '^6\\d{2}\\s\\d{3}\\s\\d{3}$';
          default : return '';
        }
      }
    }

    const onNrnInputBlur = async (validate, e) => {
      let input = e.target;
      let parent = e.target.parentElement;
      var msgError = activity?.value.catalogueTraduction?.formFormatInvalide ? activity?.value.catalogueTraduction?.formFormatInvalide : 'form.formatInvalide';

      if (validate && booking.value.nrn && booking.value.nrn.length > 0) {

        await axios.get(process.env.VUE_APP_WIDGET_API_ROOT + '/check/nrn?nrn=' + booking.value.nrn)
            .then(response => {
              if (response.data) {
                parent.classList.add('was-validated');
                input.setCustomValidity('')
              } else {
                input.setCustomValidity(msgError)
              }
            })
            .catch(error => {
              console.error('check NRN', error);
            })
            .finally(() => {
              handleHeight();
            });
      } else {
        input.setCustomValidity(msgError)
      }
      input.reportValidity();
    }

    const onFileInputChange = (doc, e) => {
      if (doc) {
        const file = e.target.files[0];
        const docIndex = booking.value.documents.findIndex(item => item.id === doc.id);
        const fileIndex = files.value.findIndex(item => item.id === doc.id);
        if (file) {
          if (docIndex > -1)
            booking.value.documents.splice(docIndex, 1);
          booking.value.documents.push({id: doc.id, fileName: doc.id + '_' + file.name});
          if (fileIndex > -1)
            files.value.splice(fileIndex, 1);
          files.value.push({id: doc.id, file: file});
        } else {
          booking.value.documents.splice(docIndex, 1);
          files.value.splice(fileIndex, 1);
        }
        handleHeight();
      }
    };

    const onFileDrop = (doc, e) => {
      const file = e.dataTransfer?.files[0];
      if (file && doc) {
        const docIndex = booking.value.documents.findIndex(item => item.id === doc.id);
        const fileIndex = files.value.findIndex(item => item.id === doc.id);
        if (docIndex > -1)
          booking.value.documents.splice(docIndex, 1);
        booking.value.documents.push({id: doc.id, fileName: doc.id + '_' + file.name});
        if (fileIndex > -1)
          files.value.splice(fileIndex, 1);
        files.value.push({id: doc.id, file: file});
        handleHeight();
      }
    };

    const onMultipleReponsesChange = (q) => {
      if (q.valeurs.length > 0)
        q.valeur = q.valeurs.join(';');
      else
        q.valeur = null;
    };

    const nextStep = async (e) => {
      let errors = 0;
      let element;

      if (e) {
        submited.value = false;
        Array.prototype.slice.call(form.value).forEach((input) => {
          if (!input.checkValidity()) {
            errors++;
            if (!element)
              element = input; // sélectionner le premier input en erreur.

            e.preventDefault();
            e.stopPropagation();
          }
        });

        if (containerCp.value != null) {
          if (!booking.value.adresse.cp && containerCp.value[0]) {
            containerCp.value[0].children[1].classList.add('is-invalid');
          } else if (containerCp.value[0]) {
            containerCp.value[0].children[1].classList.remove('is-invalid');
          }
        }

        if (containerStreet.value != null) {
          if (!booking.value.adresse.rue && containerStreet.value[0]) {
            containerStreet.value[0].children[1].classList.add('is-invalid');
          } else if (containerStreet.value[0]) {
            containerStreet.value[0].children[1].classList.remove('is-invalid');
          }
        }

        if (containerCpFact.value != null) {
          if (!booking.value.facturationIdentique && !booking.value.facturation.cp && containerCpFact.value[0]) {
            containerCpFact.value[0].children[1].classList.add('is-invalid');
          } else if (containerCpFact.value[0]) {
            containerCpFact.value[0].children[1].classList.remove('is-invalid');
          }
        }

        if (containerStreetFact.value != null) {
          if (!booking.value.facturationIdentique && !booking.value.facturation.rue && containerStreetFact.value[0]) {
            containerStreetFact.value[0].children[1].classList.add('is-invalid');
          } else if (containerStreetFact.value[0]) {
            containerStreetFact.value[0].children[1].classList.remove('is-invalid');
          }
        }
      }

      submiting.value = true;
      const formData = new FormData();
      formData.append('booking', JSON.stringify(booking.value));

      constraintError.value = false;
      await axios
          .post(process.env.VUE_APP_WIDGET_API_ROOT + '/checkConstraintAge/' + props.catalogueId + '/' + props.activityId + '/' + props.id
              , formData, {
                headers: {'Content-Type': 'multipart/form-data'}
              })
          .then(response => {
            if(response.data && response.data !== '') {
              constraintError.value = true;
              specificMessage.value = response.data;
            }
          })
          .catch(error => {
            console.error(error);
            redirectToPayement.value = false
          })
          .finally(() => {
            submiting.value = false;
          });


      if (errors > 0 || constraintError.value) {
        submited.value = true;
        handleHeight();
        if (element)
          element.scrollIntoView({behavior: 'smooth'}); // se repositionner au niveau du premier input en erreur.
      } else {
        step.value = step.value + 1;
        submited.value = false;
        scrollToTop();
      }
    };

    const prevStep = () => {
      constraintError.value = false;
      submiting.value = true;
      submited.value = false;
      step.value = step.value > 1 ? (step.value - 1) : 1;
      submiting.value = false;
      scrollToTop();
    };

    const submitBooking = async () => {
      if (!validated.value) {
        submiting.value = true;
        booking.value.activite = activity.value.activite;
        const formData = new FormData();
        formData.append('booking', JSON.stringify(booking.value));
        files.value.forEach(f => {
          formData.append('files', f.file);
        });

        await axios.post(process.env.VUE_APP_WIDGET_API_ROOT + '/booking?catalogueId=' + props.catalogueId, formData, {
          headers: {'Content-Type': 'multipart/form-data'}
        })
            .then(response => {
              validated.value = true;
              bookingError.value = false;
              if (response.data.errors) {
                validated.value = false;
                bookingError.value = true;
                // modalHeaderClasses.value = 'bg-warning text-white';
                modalMessage.value = response.data.message;
                // btnModal.value.click();
              }
              sessionStorage.clear()
            })
            .catch(error => {
              console.error('Booking error:', error.response.data);
              validated.value = false;
              bookingError.value = true;
              modalMessage.value = error.response.data.message;
            })
            .finally(() => {
              submiting.value = false;
            });
      }
    };

    const isValidPeriodeSelection = () => {
      return periodeChecked.value = booking.value.periodes.filter(p => p.checked).length > 0;
    };

    const isValidQuestionSelection = (question) => {
      return question.valeurs?.length > 0;
    };

    const onEmbarquementChange = (texte) => {
      booking.value.embarquement.texte = texte;
    };

    const onDebarquementChange = (texte) => {
      booking.value.debarquement.texte = texte;
    };

    const handleChangePlaces = async (e) => {
      if (booking.value.places > 1) {
        booking.value.avantages = false;
      }

      refreshPrice(e);
      await handleHeight();
    }

    const handleChangeAvantages = async (e) => {
      if (!e.target.checked) {
        booking.value.nrn = null
      }

      refreshPrice(e);
      await handleHeight();
    }

    const refreshPrice = (event) => {
      const isPlaine = widgetForm.value.typeActivite === constants.inscription.TYPE_ACTIVITE_PLAINE;

      booking.value.prix = activity.value.prixBaseActivite
          ? parseFloat(activity.value.prixBaseActivite)
          : Number(0.00);

      if (booking.value.avantages) {
        booking.value.prix -= activity.value.reductionMC
      }

      if (booking.value.periodes?.length > 0) {
        let periodesPrice = 0;
        booking.value.periodes.filter(p => p.checked).forEach(p => {
          periodesPrice += p.prix ? p.prix : 0;
          periodesPrice += p.garderie && p.prixGarderie ? p.prixGarderie : 0;
          periodesPrice += p.transport && p.prixTransport ? p.prixTransport : 0;
        });
        booking.value.prix += periodesPrice;
      }

      if (event && booking.value.contingents?.length > 0) {
        let optionsPrice = 0;
        const isOptionObligatoire = event.target.type === 'radio';
        const contId = parseInt(event.target.id);
        const contGrp = parseInt(event.target.name);
        booking.value.contingents.filter(c => c.checked).forEach(c => {
          if (c.id !== contId && isOptionObligatoire && c.groupe === contGrp)
            c.checked = false;
          else {
            let jours = 0;
            const reduction = c.type === constants.inscription.CONTINGENT_REDUCTION;
            if (isPlaine) {
              switch (c.typePaiement) {
                case constants.inscription.PRIX_PAR_INSCRIPTION :
                  reduction
                      ? optionsPrice -= c.prix
                      : optionsPrice += c.prix;
                  break;
                case constants.inscription.PRIX_PAR_PERIODE :
                  reduction
                      ? optionsPrice -= c.prix * booking.value.periodes.filter(p => p.checked).length
                      : optionsPrice += c.prix * booking.value.periodes.filter(p => p.checked).length;
                  break;
                case constants.inscription.PRIX_PAR_JOUR :
                  booking.value.periodes.filter(p => p.checked && p.nbJours && p.nbJours > 0).forEach(p => jours += p.nbJours);
                  if (jours > 0) {
                    reduction
                        ? optionsPrice -= c.prix * jours
                        : optionsPrice += c.prix * jours;
                  }
                  break;
              }
            } else {
              reduction
                  ? optionsPrice -= c.prix
                  : optionsPrice += c.prix;
            }
          }
        });

        booking.value.prix += optionsPrice;
      }

      if (parseFloat(booking.value.prix) < 0) {
        booking.value.prix = Number(0.00);
      } else if (booking.value.places > 1) {
        booking.value.prix = Number(booking.value.prix) * Number(booking.value.places);
      }

      store.commit('updateBooking', booking.value);
    };

    const stepClasses = ((currentStep) => {
      let classes = null;

      if (step.value === startStep.value)
        classes = 'row g-2';
      if (currentStep.style)
        classes = classes ? (classes + ' ' + currentStep.style) : currentStep.style;

      return classes;
    });

    const getLibelleForTypePaiement = ((typePaiement) => {
      let libelle = 'global.vide';

      if (!(widgetForm.value.typeActivite === constants.inscription.TYPE_ACTIVITE_PLAINE))
        return libelle;

      if (typePaiement === constants.inscription.PRIX_PAR_JOUR)
        libelle = activity?.value.catalogueTraduction?.formPaiementParJour ? activity?.value.catalogueTraduction?.formPaiementParJour : 'form.paiement.parJour';
      else if (typePaiement === constants.inscription.PRIX_PAR_PERIODE)
        libelle = activity?.value.catalogueTraduction?.formPaiementParPeriode ? activity?.value.catalogueTraduction?.formPaiementParPeriode : 'form.paiement.parPeriode';

      return libelle;
    });

    const getLibelleForPrice = (periode) => {
      if (periode.nbJours < 4)
        return activity?.value.catalogueTraduction?.activityPrixJour || 'jour';
      else if (periode.nbJours >= 4 && periode.nbJours <= 7)
        return activity?.value.catalogueTraduction?.activityPrixSemaine || 'semaine';
      else
        return activity?.value.catalogueTraduction?.activityPrixQuinzaine || 'quinzaine';
    }

    const getAllLocalities = () => {
      return localities.value;
    };

    const getAllStreets =  () => {
      if (booking.value.adresse.cp && streets.value.length === 0) {
        loadingStreets.value = true;
        axios
            .get(process.env.VUE_APP_WIDGET_API_ROOT + '/search/streets?cp=' + booking.value.adresse.cp)
            .then(response => {
              streets.value = response.data;
            })
            .catch(error => {
              console.error('getAllStreets error:', error);
            })
            .finally(() => {
              loadingStreets.value = false;
            });
      }

      return streets.value;
    };

    const cpSelectEvent = async ({text}) => {
      if (selectedLocality.value) {
        if (text?.indexOf('(') >= 0) {
          booking.value.adresse.ville = text?.slice(text?.indexOf('(') + 1, text?.indexOf(')'));
        } else {
          booking.value.adresse.ville = text?.slice(text?.indexOf(' ') + 1);
        }
        booking.value.adresse.cp = selectedLocality.value?.split(':')[1];
        sessionStorage.setItem('selectedLocality', selectedLocality.value)
        containerCp.value[0].children[1].classList.remove('is-invalid');
      } else {
        booking.value.adresse.cp = null;
        booking.value.adresse.ville = null;
        containerCp.value[0].children[1].classList.add('is-invalid');
      }
      streets.value = [];

      await handleHeight();
    };

    const streetSelectEvent = async ({text}) => {
      if(booking.value.adresse.bosa) {
        booking.value.adresse.rue = text;
        containerStreet.value[0].children[1].classList.remove('is-invalid');

        if(isNaN(booking.value.adresse.bosa)) {
          booking.value.adresse.bosa = null;
        }
      }
      else {
        booking.value.adresse.rue = null;
        containerStreet.value[0].children[1].classList.add('is-invalid');
      }

      await handleHeight();
    };

    const getAllFactStreets =  () => {
      if (booking.value.facturation.cp && streetsFact.value.length === 0) {
        loadingFactStreets.value = true;
        axios
            .get(process.env.VUE_APP_WIDGET_API_ROOT + '/search/streets?cp=' + booking.value.facturation.cp)
            .then(response => {
              streetsFact.value = response.data;
            })
            .catch(error => {
              console.error('getAllFactStreets error:', error);
            })
            .finally(() => {
              loadingFactStreets.value = false;
            });
      }

      return streetsFact.value;
    };

    const cpFactSelectEvent = async ({text}) => {
      if(selectedFactLocality.value) {
        if (text?.indexOf('(') >= 0) {
          booking.value.facturation.ville = text?.slice(text?.indexOf('(') + 1, text?.indexOf(')'));
        } else {
          booking.value.facturation.ville = text?.slice(text?.indexOf(' ') + 1);
        }
        booking.value.facturation.cp = selectedFactLocality.value?.split(':')[1];
        containerCpFact.value[0].children[1].classList.remove('is-invalid');
      }
      else {
        booking.value.facturation.cp = null;
        booking.value.facturation.ville = null;
        containerCpFact.value[0].children[1].classList.add('is-invalid');
      }
      streetsFact.value = [];

      await handleHeight();
    };

    const validateBirthDate = () => {
      if (booking.value.naissance) {
        const birthDate = new Date(booking.value.naissance);
        const activityBeginDate = parse(activity.value.debutActivite, 'dd/MM/yyyy', new Date());
        const age = differenceInYears(activityBeginDate, birthDate)

        if (activity.value.validateAge) {
          // Verify if the age is in the range of the public type defined
          let isAgeValid = false;
          let publicTypeValidationError = false;
          if (activity.value.publics?.length > 0) {
            activity.value.publics.forEach(public_type => {
              const minAgeValid = public_type.age_min === null || age >= public_type.age_min;
              const maxAgeValid = public_type.age_max === null || age <= public_type.age_max;

              if (minAgeValid && maxAgeValid) {
                isAgeValid = true;
              }
            });
            publicTypeValidationError = !isAgeValid;
          }

          const birthDateInput = document.getElementById(constants.champs.INDIVIDU_NAISSANCE);

          if (publicTypeValidationError || contingentsGroupesValidationError.value || (noContingentGroupeSelectedError.value && contingentGroupesFormStep.value < step.value)) {
            birthDateInput.classList.add('is-invalid');
            birthDateInput.setCustomValidity('invalid');
          } else {
            birthDateInput.classList.remove('is-invalid');
            birthDateInput.setCustomValidity('');
          }

          if (publicTypeValidationError || contingentsGroupesValidationError.value) {
            birthdateValidationError.value = true;
          } else {
            birthdateValidationError.value = false;
          }
        }
      }
    };

    const setContingentUnselectedWarning = (value) => {
      contingentUnselectedWarning.value = value;
    };

    const hasCompleteContingentChecked = () => {
      return booking.value.contingents.some(contingent => {
        if (contingent.checked) {
          const contingentDetails = Object.values(widgetForm.value?.contingentsGroupes || {})
              .flat()
              .find(c => c.id === contingent.id);

          return contingentDetails?.complet || false;
        }
        return false;
      });
    };

    const shouldContingentBeDisabled = (contingent) => {
      return contingent.complet && !contingent.attente;
    }

    const validateContingents = () => {
      booking.value.contingents.forEach(contingent => {
        if (contingent.checked) {
          const contingentDetails = Object.values(widgetForm.value?.contingentsGroupes || {})
              .flat()
              .find(c => c.id === contingent.id);

          if (contingentDetails) {
            if (shouldContingentBeDisabled(contingentDetails)) {
              contingent.checked = false;
            }
          }
        }
      });
    }

    const validContingents = computed(() => {
      setContingentUnselectedWarning(false);
      if (!booking.value.naissance || !activity.value.validateAge || widgetForm.value.contingents == null) return [];

      if (activity.value.validateAge) {
        const birthDate = new Date(booking.value.naissance);
        const activityBeginDate = parse(activity.value.debutActivite, 'dd/MM/yyyy', new Date());
        const age = differenceInYears(activityBeginDate, birthDate)

        const validIds = widgetForm.value.contingents
            .filter(contingent => {
              const minAgeValid = contingent.age_minimum === null || age >= contingent.age_minimum;
              const maxAgeValid = contingent.age_maximum === null || age <= contingent.age_maximum;
              return minAgeValid && maxAgeValid;
            })
            .map(c => c.id);


        booking.value.contingents.forEach(contingent => {
          const notExistsInGroups = !Object.values(widgetForm.value?.contingentsGroupes || {})
              .some(group => group.some(c => c.id === contingent.id));
          if (!validIds.includes(contingent.id) && notExistsInGroups && contingent.checked) {
            contingent.checked = false;
            setContingentUnselectedWarning(true);
          }
        });


        return validIds;
      }
      return [];
    });

    const validContingentsGroupes = computed(() => {
      if (!booking.value.naissance || !activity.value.validateAge || widgetForm.value.contingentsGroupes == null) return [];

      if (activity.value.validateAge) {
        const birthDate = new Date(booking.value.naissance);
        const activityBeginDate = parse(activity.value.debutActivite, 'dd/MM/yyyy', new Date());
        const age = differenceInYears(activityBeginDate, birthDate)

        const validIds = Object.values(widgetForm.value?.contingentsGroupes || {})
            .reduce((acc, group) => [...acc, ...group], [])
            .filter(contingent => {
              const minAgeValid = contingent.age_minimum === null || age >= contingent.age_minimum;
              const maxAgeValid = contingent.age_maximum === null || age <= contingent.age_maximum;
              return minAgeValid && maxAgeValid;
            })
            .map(c => c.id);

        // If no valid contingentsGroupes, uncheck all contingentsGroupes
        if (validIds.length === 0) {
          booking.value.contingents.forEach(contingent => {
            const existsInGroups = Object.values(widgetForm.value?.contingentsGroupes || {})
                .some(group => group.some(c => c.id === contingent.id));
            if (existsInGroups) {
              contingent.checked = false;
            }
          });
        }

        return validIds;
      }
      return [];
    });

    const contingentsValidationError = computed(() => {
      if (!activity.value.validateAge || !booking.value?.naissance || contingentGroupesFormStep.value == 0 || widgetForm.value.contingents == null) {
        return false;
      }

      const hasContingents = widgetForm.value.contingents && widgetForm.value.contingents.length > 0;
      const hasValidContingents = validContingents.value.length > 0;

      if (hasContingents && hasValidContingents) {
        return false;
      }

      return hasContingents;
    });

    const contingentsGroupesValidationError = computed(() => {
      if (!activity.value.validateAge || !booking.value?.naissance || contingentGroupesFormStep.value == 0 || widgetForm.value.contingentsGroupes == null) {
        return false;
      }

      if (validContingentsGroupes.value.length > 0) {
        return false;
      }

      const hadContingents = widgetForm.value.contingentsGroupes &&
          Object.keys(widgetForm.value.contingentsGroupes).length > 0;

      return hadContingents; // Pas d'erreur si aucun contingent défini dans contingentsGroupes pour cette activité
    });

    const streetFactSelectEvent = async ({text}) => {
      if(booking.value.facturation.bosa) {
        booking.value.facturation.rue = text;
        containerStreetFact.value[0].children[1].classList.remove('is-invalid');

        if(isNaN(booking.value.facturation.bosa)) {
          booking.value.facturation.bosa = null;
        }
      }
      else {
        booking.value.facturation.rue = null;
        containerStreetFact.value[0].children[1].classList.add('is-invalid');
      }

      await handleHeight();
    };

    const noContingentGroupeSelectedError = computed(() => {
      if (!activity.value.validateAge) {
        return false;
      }

      if (contingentGroupesFormStep.value > birthdateFormStep.value){
        return false;
      }

      const hasSelectableContingents = widgetForm.value.contingentsGroupes &&
          Object.keys(widgetForm.value.contingentsGroupes).length > 0;

      if (!hasSelectableContingents) {
        return false;
      }

      if (validContingentsGroupes.value.length === 0) {
        return false;
      }

      const isContingentSelected = booking.value.contingents
          .filter(contingent =>
              Object.values(widgetForm.value?.contingentsGroupes || {})
                  .some(group => group.some(c => c.id === contingent.id))
          )
          .some(c => c.checked);
      return !isContingentSelected;
    });

    const changeInscriptionAlternatif = () => {
      viewProcessInscriptionAlternatif.value = !viewProcessInscriptionAlternatif.value;
    }

    const doPayment = async () => {
      let errors = 0;
      let element;

      Array.prototype.slice.call(form.value).forEach((input) => {
        if (!input.checkValidity()) {
          errors++;
          if (!element)
            element = input; // sélectionner le premier input en erreur.
        }
      });

      if (errors > 0) {
        submited.value = true;
        bookingError.value = false;

        await handleHeight();
        if (element)
          element.scrollIntoView({behavior: 'smooth'}); // se repositionner au niveau du premier input en erreur.
      } else {
        removeEventListener("beforeunload", preventNav);
        redirectToPayement.value = true
        booking.value.activite = activity.value.activite;
        const formData = new FormData();
        formData.append('booking', JSON.stringify(booking.value));

        constraintError.value = false;
        await axios
            .post(process.env.VUE_APP_WIDGET_API_ROOT + '/payment/' + props.catalogueId + '/' + props.activityId + '/' + props.id
                , formData, {
                  headers: {'Content-Type': 'multipart/form-data'}
                })
            .then(response => {
              if (response.data && (response.data === 'ALREADY_BOOKED' || response.data === 'NO_PLACES')) {
                validated.value = false;
                bookingError.value = true;
                specificMessage.value = response.data;
                redirectToPayement.value = false
              } else if (response.data && !response.data.startsWith('http')) {
                validated.value = false;
                bookingError.value = false;
                constraintError.value = true;
                specificMessage.value = response.data;
                redirectToPayement.value = false
              } else {
                const redirectUrl = response.data;
                validated.value = true
                if (redirectUrl) {
                  window.location.href = redirectUrl;
                }
              }
            })
            .catch(error => {
              console.error(error);
              validated.value = false;
              bookingError.value = true;
              specificMessage.value = error;
              redirectToPayement.value = false
            });
      }
    };

    const onChangeOptin = (id, checked) => {
      booking.value.conditions.find(c => c.id === id).checked = checked
      store.commit('updateBooking', booking.value);
      sessionStorage?.setItem('booking', JSON.stringify(booking.value));
      handleHeight();
    }

    return {
      loading,
      hasError,
      widgetForm,
      constants,
      activity,
      booking,
      submiting,
      submited,
      validated,
      nextStep,
      form,
      top,
      onFormInputBlur,
      onFormInputPhoneBlur,
      isValidPeriodeSelection,
      step,
      prevStep,
      onEmbarquementChange,
      onDebarquementChange,
      refreshPrice,
      onFileInputChange,
      modalMessage,
      modalHeaderClasses,
      btnModal,
      modalRouteBtn,
      widgetURL,
      startStep,
      validationStep,
      endStep,
      validedStep,
      progress,
      onMultipleReponsesChange,
      stepClasses,
      getLibelleForTypePaiement,
      isValidQuestionSelection,
      refHeight,
      refHeightCover,
      refHeightProgress,
      refHeightBox,
      refHeightConfirm,
      handleHeight,
      formatPrice,
      onFileDrop,
      files,
      getLibelleForPrice,
      inModal,
      facturationAdrNom,
      facturationAdrPrenom,
      principalAdrNom,
      principalAdrPrenom,
      principalTelephone,
      principalGSM,
      principalMail,
      principalAdr,
      getAllLocalities,
      getAllStreets,
      cpSelectEvent,
      streetSelectEvent,
      getAllFactStreets,
      cpFactSelectEvent,
      streetFactSelectEvent,
      birthdateFormStep,
      birthdateValidationError,
      validateBirthDate,
      validateContingents,
      shouldContingentBeDisabled,
      contingentGroupesFormStep,
      validContingents,
      validContingentsGroupes,
      contingentsValidationError,
      contingentsGroupesValidationError,
      hasCompleteContingentChecked,
      contingentUnselectedWarning,
      setContingentUnselectedWarning,
      noContingentGroupeSelectedError,
      selectedLocality,
      selectedFactLocality,
      containerCp,
      containerCpFact,
      containerStreet,
      containerStreetFact,
      doPayment,
      redirectToPayement,
      onNrnInputBlur,
      handleChangeAvantages,
      handleChangePlaces,
      viewProcessInscriptionAlternatif,
      changeInscriptionAlternatif,
      bookingError,
      specificMessage,
      loadingStreets,
      loadingFactStreets,
      constraintError,
      onChangeOptin,
      getPhonePattern,
      getPhoneMaska,
    }
  }
}
</script>

<style scoped>
.form-text {
  display: block;
  width: 100%;
}

i.bi-asterisk {
  font-size: x-small;
}

div.periodes .list-group-flush > .list-group-item {
  border: none;
  padding: 2px;
}

div.periodes .form-check {
  padding-left: unset;
}

div.contingents .list-group-flush > .list-group-item {
  border: none;
  padding: 2px;
}

div.contingents .form-check {
  padding-left: unset;
}

div.error-container, div.loading-container {
  padding: 100px;
}

a.link {
  text-decoration:underline;
  color:#0000FF;
  cursor:pointer;
  padding:5px 0 15px 0;
  display:block;
}

div.infoActivitePayante {
  padding-top:10px;
}

.p-2 label {
  margin-right: 10px;
}

.p-2 .radio {
  display: none;
}

.p-2  .radio-custom {
  position: relative;
  width: 24px;
  height: 24px;
  border: 2px solid #3e8342;
  border-radius: 50%;
  display: inline-block;
  margin-top: -2px;
  vertical-align: middle;
}

.p-2 .radio:checked + .radio-custom::before {
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  display: block;
  content: "";
  background: #fff;
  border: 5px solid #3e8342;
  border-radius: 50%;
}

.p-2 .radio-custom-label {
  margin-left: 6px;
}

.p-2 .radio:checked + .disabled::before {
  background: #6e7687;
  border: 5px solid #6e7687;
}
</style>
